<template>
  <div
    id="top"
    class="w-100 space-for-navbar mb-3"
  >
    <div
      id="SplashContainer"
      class="m-0 p-0 centered-on-page"
    >
      <div class="m-0 p-0 w-100 h-100">
        <svg
          class="m-0 p-0"
          xmlns="http://www.w3.org/2000/svg"
          xmlns:xlink="http://www.w3.org/1999/xlink"
          viewBox="0 0 1000 560"
        >
          <title>Science</title>
          <g id="Splashes">
            <g id="Science">
              <image
                id="banner1"
                width="1000"
                height="560"
                transform="translate(0, 0)"
                :xlink:href="require('../assets/splashes/SplashScience1.jpg')"
              />
              <g id="BannerLabel1">
                <text
                  class="bmg-splashes-15"
                  transform="translate(265 235)"
                >Science</text>
                <text
                  class="bmg-splashes-23"
                  transform="translate(265 265)"
                >Medical</text>
                <text
                  class="bmg-splashes-23"
                  transform="translate(265 295)"
                >Immersion in</text>
                <text
                  class="bmg-splashes-23"
                  transform="translate(265 325)"
                >Physician</text>
                <text
                  class="bmg-splashes-23"
                  transform="translate(265 355)"
                >Assisted</text>
                <text
                  class="bmg-splashes-23"
                  transform="translate(265 385)"
                >Bone Healing</text>
              </g>
              <image
                id="banner2"
                width="1000"
                height="560"
                transform="translate(0, 0)"
                :xlink:href="require('../assets/splashes/SplashScience2.jpg')"
              />
              <g id="BannerLabel2">
                <text
                  class="bmg-splashes-15"
                  transform="translate(300 180)"
                >Science</text>
                <text
                  class="bmg-splashes-23"
                  transform="translate(300 210)"
                >Medical</text>
                <text
                  class="bmg-splashes-23"
                  transform="translate(300 240)"
                >Immersion in</text>
                <text
                  class="bmg-splashes-23"
                  transform="translate(300 270)"
                >Physician</text>
                <text
                  class="bmg-splashes-23"
                  transform="translate(300 300)"
                >Assisted</text>
                <text
                  class="bmg-splashes-23"
                  transform="translate(300 330)"
                >Bone Healing</text>
              </g>
              <image
                id="banner3"
                width="1000"
                height="560"
                transform="translate(0, 0)"
                :xlink:href="require('../assets/splashes/SplashScience3.jpg')"
              />
              <g id="BannerLabel3">
                <text
                  class="bmg-splashes-15"
                  transform="translate(250 230)"
                >Science</text>
                <text
                  class="bmg-splashes-23"
                  transform="translate(250 260)"
                >Define Criteria</text>
                <text
                  class="bmg-splashes-23"
                  transform="translate(250 290)"
                >Causing Unmet</text>
                <text
                  class="bmg-splashes-23"
                  transform="translate(250 320)"
                >Need</text>
              </g>
              <image
                id="banner4"
                width="1000"
                height="560"
                transform="translate(0, 0)"
                :xlink:href="require('../assets/splashes/SplashScience4.jpg')"
              />
              <g id="BannerLabel4">
                <text
                  class="bmg-splashes-15"
                  transform="translate(280 280)"
                >Science</text>
                <text
                  class="bmg-splashes-23"
                  transform="translate(280 310)"
                >Define Criteria</text>
                <text
                  class="bmg-splashes-23"
                  transform="translate(280 340)"
                >Causing Unmet</text>
                <text
                  class="bmg-splashes-23"
                  transform="translate(280 370)"
                >Need</text>
              </g>
            </g>
          </g>
        </svg>
      </div>
    </div>
    <div class="w-100 m-0 p-0 bg-dark">
      <div
        id="AnimationContainer"
        class="centered-on-page"
      >
        <div :style="(windowWidth > (windowHeight * 1.75)) ? {height: '100%', width: (windowHeight * 1.75) + 'px'} : {width: '100%', height: (windowWidth * 0.57) + 'px'}">
          <svg
            v-show="!zooming"
            xmlns="http://www.w3.org/2000/svg"
            xmlns:xlink="http://www.w3.org/1999/xlink"
            viewBox="0 0 1050 602"
          >
            <defs>
              <image
                id="healedBonePic"
                width="296"
                height="297"
                :xlink:href="require('../assets/medical_pics/HealedBone.png')"
              />
            </defs>
            <!-- <title>Bone Healing Animation</title> -->
            <g id="Sequences">
              <line
                id="StartLine"
                class="bmg-science-animation-2"
                x1="76.5"
                y1="332.5"
                x2="345.5"
                y2="331.5"
              />
              <g id="TopLine">
                <g id="Top_Dashed_Line">
                  <g>
                    <path
                      class="bmg-science-animation-4"
                      d="M345.11,334.84c.29-1.65.6-3.29.92-4.92"
                    />
                    <path
                      class="bmg-science-animation-6"
                      d="M348.2,320.1c58-237.66,449.24-163.73,591.12-67.41"
                    />
                    <path
                      class="bmg-science-animation-4"
                      d="M943.45,255.55c1.38,1,2.73,1.95,4,2.92"
                    />
                  </g>
                </g>
                <polygon
                  class="bmg-science-animation-3"
                  points="956.24 260.63 925.41 262.32 939.36 234.78 956.24 260.63"
                />
              </g>
              <g id="BottomLine">
                <polygon
                  id="BottomArrowHead"
                  class="bmg-science-animation-3"
                  points="658.2 466 633.08 481.44 633.08 450.56 658.2 466"
                />
                <g id="Bottom_Dashed_Line">
                  <g>
                    <path
                      class="bmg-science-animation-4"
                      d="M340.35,341.71c.32,1.65.66,3.28,1,4.89"
                    />
                    <path
                      class="bmg-science-animation-5"
                      d="M344,356c36.08,113.61,221.29,118.9,283.17,111"
                    />
                    <path
                      class="bmg-science-animation-4"
                      d="M632,466.36c1.79-.28,3.43-.57,4.93-.86"
                    />
                  </g>
                </g>
              </g>
              <g id="_04Sequence">
                <g id="SavingsLine">
                  <line
                    id="GreenArrowLine"
                    class="bmg-science-animation-7"
                    x1="664.96"
                    y1="411.4"
                    x2="956.31"
                    y2="411"
                  />
                  <text
                    class="bmg-science-animation-8"
                    transform="translate(686.76 402.24)"
                  >S<tspan
                    class="bmg-science-animation-9"
                    x="9.93"
                    y="0"
                  >a</tspan><tspan
                    class="bmg-science-animation-10"
                    x="19.38"
                    y="0"
                  >v</tspan><tspan
                    x="28.45"
                    y="0"
                  >es Months of </tspan><tspan
                    class="bmg-science-animation-10"
                    x="137.56"
                    y="0"
                  >P</tspan><tspan
                    x="148.72"
                    y="0"
                  >ain &amp; </tspan><tspan
                    class="bmg-science-animation-11"
                    x="193.9"
                    y="0"
                  >T</tspan><tspan
                    class="bmg-science-animation-12"
                    x="203.33"
                    y="0"
                  >i</tspan><tspan
                    class="bmg-science-animation-13"
                    x="208.02"
                    y="0"
                  >m</tspan><tspan
                    x="224.44"
                    y="0"
                  >e!!!</tspan></text>
                </g>
                <g id="PrimaryHealingArrow">
                  <g id="GreenArrow">
                    <line
                      id="GreenArrowLine-2"
                      data-name="GreenArrowLine"
                      class="bmg-science-animation-7"
                      x1="515.3"
                      y1="411.35"
                      x2="636.81"
                      y2="411.4"
                    />
                    <polygon
                      id="GreenArrowHead"
                      class="bmg-science-animation-14"
                      points="658 411.32 635.19 426.76 635.19 395.89 658 411.32"
                    />
                  </g>
                  <text
                    class="bmg-science-animation-15"
                    transform="translate(514.92 370.88)"
                  ><tspan class="bmg-science-animation-16">P</tspan><tspan
                    class="bmg-science-animation-17"
                    x="15.56"
                    y="0"
                  >r</tspan><tspan
                    x="24.76"
                    y="0"
                  >ima</tspan><tspan
                    class="bmg-science-animation-18"
                    x="67.15"
                    y="0"
                  >r</tspan><tspan
                    x="76.76"
                    y="0"
                  >y / Di</tspan><tspan
                    class="bmg-science-animation-19"
                    x="134.57"
                    y="0"
                  >r</tspan><tspan
                    x="143.67"
                    y="0"
                  >e</tspan><tspan
                    class="bmg-science-animation-20"
                    x="157.26"
                    y="0"
                  >c</tspan><tspan
                    x="170.17"
                    y="0"
                  >t</tspan><tspan
                    x="0"
                    y="25.86"
                  >H</tspan><tspan
                    class="bmg-science-animation-21"
                    x="17.41"
                    y="25.86"
                  >e</tspan><tspan
                    x="30.69"
                    y="25.86"
                  >ali</tspan><tspan
                    class="bmg-science-animation-22"
                    x="56.95"
                    y="25.86"
                  >n</tspan><tspan
                    x="71.97"
                    y="25.86"
                  >g</tspan></text>
                </g>
                <g
                  id="BottomFullyRestoredBone"
                  class="pointer"
                  @click="doZoom('PrimaryFinalBone', 1)"
                >
                  <g id="BottomFullyRestoredBoneLabel">
                    <text
                      class="bmg-science-animation-29"
                      transform="translate(680.77 530)"
                    >Bo<tspan
                      class="bmg-science-animation-30"
                      x="17.52"
                      y="0"
                    >n</tspan><tspan
                      x="26.13"
                      y="0"
                    >e</tspan></text>
                    <text
                      class="bmg-science-animation-29"
                      transform="translate(652.45 513.94)"
                    ><tspan class="bmg-science-animation-31">F</tspan><tspan
                      class="bmg-science-animation-32"
                      x="7.8"
                      y="0"
                    >ully Res</tspan><tspan
                      class="bmg-science-animation-33"
                      x="56.39"
                      y="0"
                    >t</tspan><tspan
                      x="61.3"
                      y="0"
                    >o</tspan><tspan
                      class="bmg-science-animation-34"
                      x="69.25"
                      y="0"
                    >r</tspan><tspan
                      x="74.17"
                      y="0"
                    >ed</tspan></text>
                  </g>
                  <use
                    id="BottomFullyRestoredBonePic"
                    transform="translate(658 423) scale(0.27 0.27)"
                    xlink:href="#healedBonePic"
                  />
                </g>
                <g
                  id="DirectHaversianRemodeling"
                  class="pointer"
                  @click="doZoom('DirectHaversian', 1)"
                >
                  <text
                    id="DirectHaversianRemodelingLabel"
                    class="bmg-science-animation-35"
                    transform="translate(520.86 522.82)"
                  >Di<tspan
                    class="bmg-science-animation-36"
                    x="13.11"
                    y="0"
                  >r</tspan><tspan
                    x="17.75"
                    y="0"
                  >e</tspan><tspan
                    class="bmg-science-animation-37"
                    x="24.98"
                    y="0"
                  >c</tspan><tspan
                    x="31.8"
                    y="0"
                  >t H</tspan><tspan
                    class="bmg-science-animation-38"
                    x="49.53"
                    y="0"
                  >a</tspan><tspan
                    class="bmg-science-animation-39"
                    x="56.47"
                    y="0"
                  >v</tspan><tspan
                    x="62.78"
                    y="0"
                  >e</tspan><tspan
                    class="bmg-science-animation-40"
                    x="70.01"
                    y="0"
                  >r</tspan><tspan
                    class="bmg-science-animation-41"
                    x="74.76"
                    y="0"
                  >sian</tspan><tspan
                    x="12.38"
                    y="14.37"
                  >Re</tspan><tspan
                    class="bmg-science-animation-42"
                    x="28.27"
                    y="14.37"
                  >m</tspan><tspan
                    x="40.99"
                    y="14.37"
                  >odeli</tspan><tspan
                    class="bmg-science-animation-43"
                    x="70.29"
                    y="14.37"
                  >n</tspan><tspan
                    x="78.41"
                    y="14.37"
                  >g</tspan></text>
                  <image
                    class="animation-google-tracking"
                    tracking-info="Zoom to Direct Haversian"
                    id="DirectHaversianRemodelingPic"
                    width="777"
                    height="812"
                    transform="translate(536 430) scale(0.1 0.1)"
                    :xlink:href="require('../assets/medical_pics/HaversianRemodeling_BoneSegment.png')"
                  />
                </g>
                <g
                  id="CompressionSustained"
                  class="pointer"
                  @click="doZoom('IntimateAlignment', 2)"
                >
                  <g id="CompressionSustainedBottomLabel">
                    <text
                      class="bmg-science-animation-29"
                      transform="translate(441.9 516.15)"
                    >Intima<tspan
                      class="bmg-science-animation-33"
                      x="41.92"
                      y="0"
                    >t</tspan><tspan
                      x="46.83"
                      y="0"
                    >e</tspan></text>
                    <text
                      class="bmg-science-animation-29"
                      transform="translate(435.11 529.75)"
                    >Align<tspan
                      class="bmg-science-animation-44"
                      x="33.2"
                      y="0"
                    >m</tspan><tspan
                      class="bmg-science-animation-32"
                      x="46.69"
                      y="0"
                    >ent</tspan></text>
                  </g>
                  <text
                    id="CompressionSustainedLabel"
                    class="bmg-science-animation-35"
                    transform="translate(429.42 402.59)"
                  ><tspan class="bmg-science-animation-45">C</tspan><tspan
                    class="bmg-science-animation-46"
                    x="8.33"
                    y="0"
                  >omp</tspan><tspan
                    class="bmg-science-animation-47"
                    x="36.66"
                    y="0"
                  >r</tspan><tspan
                    x="41.3"
                    y="0"
                  >ession</tspan><tspan
                    x="9.59"
                    y="14.37"
                  >Sustai</tspan><tspan
                    class="bmg-science-animation-42"
                    x="46.01"
                    y="14.37"
                  >n</tspan><tspan
                    class="bmg-science-animation-46"
                    x="54.13"
                    y="14.37"
                  >ed</tspan></text>
                  <image
                    class="animation-google-tracking"
                    tracking-info="Zoom to Compression Sustained"
                    id="CompressionSustainedPic"
                    width="298"
                    height="298"
                    transform="translate(429 422) scale(0.27 0.27)"
                    :xlink:href="require('../assets/medical_pics/IntimateUnion.png')"
                  />
                </g>
                <g
                  id="BMGFixation"
                  class="pointer"
                  @click="doZoom('BMGHardware', 2)"
                >
                  <image
                    class="animation-google-tracking"
                    tracking-info="Zoom to BMG Fixation"
                    width="1085"
                    height="941"
                    transform="translate(301 404.4) rotate(-0.22) scale(0.1)"
                    :xlink:href="require('../assets/animations/FullAnimation1.png')"
                  />
                  <text
                    id="BMGFixation_Label"
                    class="bmg-science-animation-35"
                    transform="translate(313.45 398.29)"
                  >BMG <tspan
                    class="bmg-science-animation-38"
                    x="32.85"
                    y="0"
                  >F</tspan><tspan
                    x="40.31"
                    y="0"
                  >i</tspan><tspan
                    class="bmg-science-animation-38"
                    x="43.53"
                    y="0"
                  >x</tspan><tspan
                    x="49.8"
                    y="0"
                  >ation</tspan></text>
                  <text
                    id="EarlyWeightBearing_Label"
                    class="bmg-science-animation-35"
                    transform="translate(163.42 436.42)"
                  >I<tspan
                    class="bmg-science-animation-43"
                    x="3.62"
                    y="0"
                  >n</tspan><tspan
                    class="bmg-science-animation-41"
                    x="11.74"
                    y="0"
                  >c</tspan><tspan
                    class="bmg-science-animation-47"
                    x="18.48"
                    y="0"
                  >r</tspan><tspan
                    class="bmg-science-animation-39"
                    x="23.13"
                    y="0"
                  >e</tspan><tspan
                    class="bmg-science-animation-41"
                    x="30.18"
                    y="0"
                  >ased Blood Fl</tspan><tspan
                    class="bmg-science-animation-39"
                    x="110.89"
                    y="0"
                  >o</tspan><tspan
                    x="118.22"
                    y="0"
                  >w</tspan><tspan
                    x="36.88"
                    y="14.37"
                  >a</tspan><tspan
                    class="bmg-science-animation-43"
                    x="43.95"
                    y="14.37"
                  >n</tspan><tspan
                    class="bmg-science-animation-41"
                    x="52.08"
                    y="14.37"
                  >d </tspan><tspan
                    class="bmg-science-animation-45"
                    x="63.33"
                    y="14.37"
                  >P</tspan><tspan
                    class="bmg-science-animation-36"
                    x="71.65"
                    y="14.37"
                  >r</tspan><tspan
                    class="bmg-science-animation-48"
                    x="76.29"
                    y="14.37"
                  >e</tspan><tspan
                    class="bmg-science-animation-39"
                    x="83.41"
                    y="14.37"
                  >v</tspan><tspan
                    x="89.72"
                    y="14.37"
                  >ention</tspan><tspan
                    x="62.78"
                    y="28.73"
                    xml:space="preserve"
                  >of  </tspan><tspan
                    class="bmg-science-animation-49"
                    x="80.62"
                    y="28.73"
                  >A</tspan><tspan
                    x="89.14"
                    y="28.73"
                  >t</tspan><tspan
                    class="bmg-science-animation-47"
                    x="94"
                    y="28.73"
                  >r</tspan><tspan
                    x="98.65"
                    y="28.73"
                  >op</tspan><tspan
                    class="bmg-science-animation-48"
                    x="114.27"
                    y="28.73"
                  >h</tspan><tspan
                    x="122.25"
                    y="28.73"
                  >y</tspan></text>
                </g>
              </g>
              <g id="_03Sequence">
                <g id="SecondaryHealingArrow">
                  <g id="RedArrow">
                    <line
                      id="RedArrowLine"
                      class="bmg-science-animation-23"
                      x1="515.74"
                      y1="282.72"
                      x2="925.15"
                      y2="282.96"
                    />
                    <polygon
                      id="RedArrowHead"
                      class="bmg-science-animation-24"
                      points="949.83 282.96 923.09 298.4 923.09 267.52 949.83 282.96"
                    />
                  </g>
                  <text
                    class="bmg-science-animation-15"
                    transform="translate(514.92 311.87)"
                  >Se<tspan
                    class="bmg-science-animation-25"
                    x="27.35"
                    y="0"
                  >c</tspan><tspan
                    x="39.93"
                    y="0"
                  >o</tspan><tspan
                    class="bmg-science-animation-22"
                    x="54.04"
                    y="0"
                  >n</tspan><tspan
                    x="69.06"
                    y="0"
                  >da</tspan><tspan
                    class="bmg-science-animation-18"
                    x="97.27"
                    y="0"
                  >r</tspan><tspan
                    x="106.88"
                    y="0"
                  >y / I</tspan><tspan
                    class="bmg-science-animation-22"
                    x="147.48"
                    y="0"
                  >n</tspan><tspan
                    class="bmg-science-animation-26"
                    x="162.5"
                    y="0"
                  >di</tspan><tspan
                    class="bmg-science-animation-27"
                    x="183.9"
                    y="0"
                  >r</tspan><tspan
                    class="bmg-science-animation-26"
                    x="192.99"
                    y="0"
                  >e</tspan><tspan
                    class="bmg-science-animation-28"
                    x="206.59"
                    y="0"
                  >c</tspan><tspan
                    class="bmg-science-animation-26"
                    x="219.5"
                    y="0"
                  >t H</tspan><tspan
                    class="bmg-science-animation-21"
                    x="252.38"
                    y="0"
                  >e</tspan><tspan
                    x="265.65"
                    y="0"
                  >ali</tspan><tspan
                    class="bmg-science-animation-22"
                    x="291.92"
                    y="0"
                  >n</tspan><tspan
                    x="306.94"
                    y="0"
                  >g</tspan></text>
                </g>
                <g
                  id="TopFullyRestoredBone"
                  class="pointer"
                  @click="doZoom('SecondaryFinalBone', 1)"
                >
                  <g id="TopFullyRestoredBone_Label">
                    <text
                      class="bmg-science-animation-29"
                      transform="translate(954.5 209.74)"
                    ><tspan class="bmg-science-animation-31">F</tspan><tspan
                      class="bmg-science-animation-32"
                      x="7.8"
                      y="0"
                    >ully Res</tspan><tspan
                      class="bmg-science-animation-33"
                      x="56.39"
                      y="0"
                    >t</tspan><tspan
                      x="61.3"
                      y="0"
                    >o</tspan><tspan
                      class="bmg-science-animation-34"
                      x="69.25"
                      y="0"
                    >r</tspan><tspan
                      x="74.17"
                      y="0"
                    >ed</tspan></text>
                    <text
                      class="bmg-science-animation-29"
                      transform="translate(982.83 224.99)"
                    >Bo<tspan
                      class="bmg-science-animation-30"
                      x="17.52"
                      y="0"
                    >n</tspan><tspan
                      x="26.13"
                      y="0"
                    >e</tspan></text>
                  </g>
                  <use
                    id="TopFullyRestoredBonePic"
                    transform="translate(960 227.98) scale(0.27 0.27)"
                    xlink:href="#healedBonePic"
                  />
                </g>
                <g
                  id="SecondaryHaversianRemodeling"
                  class="pointer"
                  @click="doZoom('SecondaryHaversianRemodeling', 1)"
                >
                  <g id="SecondaryHaversianRemodelingLabel">
                    <text
                      class="bmg-science-animation-29"
                      transform="translate(850.33 153.45)"
                    >H<tspan
                      class="bmg-science-animation-50"
                      x="10.31"
                      y="0"
                    >a</tspan><tspan
                      class="bmg-science-animation-51"
                      x="17.67"
                      y="0"
                    >v</tspan><tspan
                      x="24.35"
                      y="0"
                    >e</tspan><tspan
                      class="bmg-science-animation-52"
                      x="32.01"
                      y="0"
                    >r</tspan><tspan
                      x="37.05"
                      y="0"
                    >sian</tspan></text>
                    <text
                      class="bmg-science-animation-29"
                      transform="translate(842.37 166.43)"
                    >Re<tspan
                      class="bmg-science-animation-30"
                      x="16.83"
                      y="0"
                    >m</tspan><tspan
                      x="30.31"
                      y="0"
                    >odeli</tspan><tspan
                      class="bmg-science-animation-30"
                      x="61.35"
                      y="0"
                    >n</tspan><tspan
                      x="69.96"
                      y="0"
                    >g</tspan></text>
                  </g>
                  <image
                    class="animation-google-tracking"
                    tracking-info="Zoom to Secondary Haversian Remodeling"
                    id="SecondaryHaversianRemodelingPic"
                    width="784"
                    height="816"
                    transform="translate(844.01 172.98) scale(0.1 0.1)"
                    :xlink:href="require('../assets/medical_pics/SecondaryHaversianRemodeling.png')"
                  />
                </g>
                <g
                  id="SecondaryHealing"
                  class="pointer"
                  @click="doZoom('SecondaryHealing', 1)"
                >
                  <g id="PhasesLabels">
                    <text
                      id="PhasesOfCallusReaction_Label"
                      class="bmg-science-animation-53"
                      transform="translate(720.63 99.21)"
                    >Phases of <tspan
                      class="bmg-science-animation-40"
                      x="63.94"
                      y="0"
                    >C</tspan><tspan
                      class="bmg-science-animation-41"
                      x="72.67"
                      y="0"
                    >allus</tspan><tspan
                      class="bmg-science-animation-54"
                      x="18.27"
                      y="14.37"
                    >F</tspan><tspan
                      x="25.75"
                      y="14.37"
                    >o</tspan><tspan
                      class="bmg-science-animation-55"
                      x="33.59"
                      y="14.37"
                    >r</tspan><tspan
                      x="38.7"
                      y="14.37"
                    >mation</tspan></text>
                    <g>
                      <text
                        id="PhasesOfCallusReaction_Label-2"
                        data-name="PhasesOfCallusReaction_Label"
                        class="bmg-science-animation-56"
                        transform="translate(732.65 127.93)"
                      >Soft</text>
                      <text
                        id="PhasesOfCallusReaction_Label-3"
                        data-name="PhasesOfCallusReaction_Label"
                        class="bmg-science-animation-56"
                        transform="translate(784.27 127.93)"
                      >Ha<tspan
                        class="bmg-science-animation-57"
                        x="16.72"
                        y="0"
                      >r</tspan><tspan
                        x="21.27"
                        y="0"
                      >d</tspan></text>
                    </g>
                  </g>
                  <image
                    class="animation-google-tracking"
                    tracking-info="Zoom to Secondary Healing Phases"
                    id="PhasesPic"
                    width="586"
                    height="600"
                    transform="translate(719.02 128.99) scale(0.18 0.18)"
                    :xlink:href="require('../assets/medical_pics/CallusReactionPhases.png')"
                  />
                </g>
                <g
                  id="Inflammation"
                  class="pointer"
                  @click="doZoom('SecondaryHealing', 1)"
                >
                  <g id="InflammationLabels">
                    <text
                      id="Tissue"
                      class="bmg-science-animation-56"
                      transform="translate(613.29 114.07)"
                    ><tspan class="bmg-science-animation-57">T</tspan><tspan
                      class="bmg-science-animation-46"
                      x="6.57"
                      y="0"
                    >issue </tspan><tspan
                      class="bmg-science-animation-58"
                      x="39.37"
                      y="0"
                    >F</tspan><tspan
                      class="bmg-science-animation-41"
                      x="46.7"
                      y="0"
                    >o</tspan><tspan
                      class="bmg-science-animation-59"
                      x="54.12"
                      y="0"
                    >r</tspan><tspan
                      x="58.73"
                      y="0"
                    >mation</tspan></text>
                    <text
                      id="Granulation"
                      class="bmg-science-animation-56"
                      transform="translate(629.01 99.27)"
                    >G<tspan
                      class="bmg-science-animation-59"
                      x="9.25"
                      y="0"
                    >r</tspan><tspan
                      x="13.86"
                      y="0"
                    >anulation</tspan></text>
                    <text
                      id="Inflammation-2"
                      data-name="Inflammation"
                      class="bmg-science-animation-56"
                      transform="translate(618.02 84.48)"
                    >Inflammation &amp;</text>
                  </g>
                  <image
                    class="animation-google-tracking"
                    tracking-info="Zoom to Inflamation"
                    id="InflammationPic"
                    width="264"
                    height="600"
                    transform="translate(640.02 113.99) scale(0.18 0.18)"
                    :xlink:href="require('../assets/medical_pics/Inflammation.png')"
                  />
                </g>
              </g>
              <g id="_02Sequence">
                <g
                  id="NaturalGapWidening"
                  class="pointer"
                  @click="doZoom('CompressionLost', 4)"
                >
                  <image
                    class="animation-google-tracking"
                    tracking-info="Zoom to Natural Gap Widening"
                    id="NaturalGapWideningPic"
                    width="409"
                    height="451"
                    transform="translate(537.02 117.99) scale(0.18 0.18)"
                    :xlink:href="require('../assets/medical_pics/TraditionalGapWideningBoneSegment.png')"
                  />
                  <text
                    id="Natural"
                    class="bmg-science-animation-35"
                    transform="translate(550.47 86.2)"
                  >Natu<tspan
                    class="bmg-science-animation-60"
                    x="29.71"
                    y="0"
                  >r</tspan><tspan
                    x="34.41"
                    y="0"
                  >al</tspan></text>
                  <text
                    class="bmg-science-animation-35"
                    transform="translate(560.6 99.68)"
                  >Gap</text>
                  <text
                    class="bmg-science-animation-35"
                    transform="translate(543.16 113.16)"
                  ><tspan class="bmg-science-animation-61">W</tspan><tspan
                    x="13.08"
                    y="0"
                  >ideni</tspan><tspan
                    class="bmg-science-animation-42"
                    x="42.98"
                    y="0"
                  >n</tspan><tspan
                    x="51.11"
                    y="0"
                  >g</tspan></text>
                </g>
                <g
                  id="CompressionLost"
                  class="pointer"
                  @click="doZoom('CompressionLost', 4)"
                >
                  <text
                    id="CompressionLostBottomLabel"
                    class="bmg-science-animation-35"
                    transform="translate(470.89 233.62)"
                  ><tspan class="bmg-science-animation-45">C</tspan><tspan
                    class="bmg-science-animation-46"
                    x="8.33"
                    y="0"
                  >omp</tspan><tspan
                    class="bmg-science-animation-47"
                    x="36.66"
                    y="0"
                  >r</tspan><tspan
                    x="41.3"
                    y="0"
                  >ession </tspan><tspan
                    class="bmg-science-animation-62"
                    x="82.21"
                    y="0"
                  >L</tspan><tspan
                    x="89.17"
                    y="0"
                  >ost</tspan></text>
                  <g id="CompressionLostTopLabel">
                    <text
                      class="bmg-science-animation-29"
                      transform="translate(440.54 73.03)"
                    ><tspan class="bmg-science-animation-63">F</tspan><tspan
                      x="7.76"
                      y="0"
                    >ailu</tspan><tspan
                      class="bmg-science-animation-34"
                      x="30.6"
                      y="0"
                    >r</tspan><tspan
                      x="35.53"
                      y="0"
                    >e of </tspan></text>
                    <text
                      class="bmg-science-animation-29"
                      transform="translate(430.4 88.48)"
                    ><tspan class="bmg-science-animation-64">c</tspan><tspan
                      x="7.03"
                      y="0"
                    >o</tspan><tspan
                      class="bmg-science-animation-65"
                      x="14.98"
                      y="0"
                    >n</tspan><tspan
                      class="bmg-science-animation-66"
                      x="23.44"
                      y="0"
                    >v</tspan><tspan
                      x="30.12"
                      y="0"
                    >entional</tspan></text>
                    <text
                      class="bmg-science-animation-29"
                      transform="translate(411.47 103.93)"
                    >implants <tspan
                      class="bmg-science-animation-33"
                      x="59.62"
                      y="0"
                    >t</tspan><tspan
                      class="bmg-science-animation-32"
                      x="64.53"
                      y="0"
                    >o </tspan><tspan
                      class="bmg-science-animation-34"
                      x="75.81"
                      y="0"
                    >r</tspan><tspan
                      class="bmg-science-animation-32"
                      x="80.73"
                      y="0"
                    >edu</tspan><tspan
                      class="bmg-science-animation-64"
                      x="105.52"
                      y="0"
                    >c</tspan><tspan
                      x="112.55"
                      y="0"
                    >e</tspan></text>
                    <text
                      class="bmg-science-animation-29"
                      transform="translate(416.25 119.38)"
                    >in<tspan
                      class="bmg-science-animation-33"
                      x="12"
                      y="0"
                    >t</tspan><tspan
                      x="16.91"
                      y="0"
                    >er</tspan><tspan
                      class="bmg-science-animation-67"
                      x="29.65"
                      y="0"
                    >f</tspan><tspan
                      class="bmg-science-animation-64"
                      x="34.97"
                      y="0"
                    >r</tspan><tspan
                      class="bmg-science-animation-44"
                      x="39.94"
                      y="0"
                    >a</tspan><tspan
                      x="47.45"
                      y="0"
                    >g</tspan><tspan
                      class="bmg-science-animation-30"
                      x="56.15"
                      y="0"
                    >m</tspan><tspan
                      x="69.63"
                      y="0"
                    >enta</tspan><tspan
                      class="bmg-science-animation-68"
                      x="98.51"
                      y="0"
                    >r</tspan><tspan
                      x="103.78"
                      y="0"
                    >y</tspan></text>
                    <text
                      class="bmg-science-animation-29"
                      transform="translate(431.36 134.83)"
                    >st<tspan
                      class="bmg-science-animation-64"
                      x="11.35"
                      y="0"
                    >r</tspan><tspan
                      class="bmg-science-animation-69"
                      x="16.32"
                      y="0"
                    >ain </tspan><tspan
                      class="bmg-science-animation-33"
                      x="39.13"
                      y="0"
                    >t</tspan><tspan
                      x="44.04"
                      y="0"
                    >o &lt;</tspan><tspan
                      class="bmg-science-animation-70"
                      x="62.6"
                      y="0"
                    >2</tspan><tspan
                      x="69.93"
                      y="0"
                    >%</tspan></text>
                  </g>
                  <image
                    class="animation-google-tracking"
                    tracking-info="Zoom to Compression Lost"
                    id="CompressionLostPic"
                    width="308"
                    height="312"
                    transform="translate(432 141) scale(0.26)"
                    :xlink:href="require('../assets/medical_pics/GapWidening.png')"
                  />
                </g>
                <g
                  id="HighlyRestricted"
                  class="pointer"
                  @click="doZoom('HighlyRestricted', 2)"
                >
                  <text
                    id="HighlyRestricted_Label"
                    class="bmg-science-animation-35"
                    transform="translate(241.3 205.95)"
                  >Musculos<tspan
                    class="bmg-science-animation-71"
                    x="56.72"
                    y="0"
                  >k</tspan><tspan
                    x="63.67"
                    y="0"
                  >eletal</tspan><tspan
                    class="bmg-science-animation-48"
                    x="1.15"
                    y="14.37"
                  >S</tspan><tspan
                    class="bmg-science-animation-72"
                    x="8.39"
                    y="14.37"
                  >y</tspan><tspan
                    x="14.81"
                    y="14.37"
                  >s</tspan><tspan
                    class="bmg-science-animation-73"
                    x="20.66"
                    y="14.37"
                  >t</tspan><tspan
                    class="bmg-science-animation-46"
                    x="25.3"
                    y="14.37"
                  >em </tspan><tspan
                    class="bmg-science-animation-74"
                    x="48.37"
                    y="14.37"
                  >A</tspan><tspan
                    x="56.89"
                    y="14.37"
                  >t</tspan><tspan
                    class="bmg-science-animation-36"
                    x="61.75"
                    y="14.37"
                  >r</tspan><tspan
                    class="bmg-science-animation-46"
                    x="66.39"
                    y="14.37"
                  >op</tspan><tspan
                    class="bmg-science-animation-48"
                    x="82.02"
                    y="14.37"
                  >h</tspan><tspan
                    x="90"
                    y="14.37"
                  >y</tspan></text>
                  <image
                    class="animation-google-tracking"
                    tracking-info="Zoom to Highly Restricted Bearing"
                    id="HighlyRestricted_Pic"
                    width="600"
                    height="409"
                    transform="translate(296.61 155.98) scale(0.25 0.25)"
                    :xlink:href="require('../assets/purchased_pics/shutterstock_1023277171_transparent_background.png')"
                  />
                </g>
                <g
                  id="_02Explanation"
                  data-name="02Explanation"
                >
                  <g
                    id="_02Text"
                    data-name="02Text"
                  >
                    <text
                      id="_02Text_06"
                      data-name="02Text_06"
                      class="bmg-science-animation-80"
                      transform="translate(45.37 182.27)"
                    >bo<tspan
                      class="bmg-science-animation-81"
                      x="21.87"
                      y="0"
                    >n</tspan><tspan
                      x="33.25"
                      y="0"
                    >e </tspan><tspan
                      class="bmg-science-animation-81"
                      x="47.77"
                      y="0"
                    >h</tspan><tspan
                      class="bmg-science-animation-82"
                      x="59.15"
                      y="0"
                    >e</tspan><tspan
                      x="69.02"
                      y="0"
                    >ali</tspan><tspan
                      class="bmg-science-animation-81"
                      x="87.92"
                      y="0"
                    >n</tspan><tspan
                      class="bmg-science-animation-83"
                      x="99.3"
                      y="0"
                    >g</tspan></text>
                    <text
                      id="_02Text_05"
                      data-name="02Text_05"
                      class="bmg-science-animation-80"
                      transform="translate(45.37 160.93)"
                    >in st<tspan
                      class="bmg-science-animation-84"
                      x="35.25"
                      y="0"
                    >r</tspan><tspan
                      x="41.82"
                      y="0"
                    >ain all</tspan><tspan
                      class="bmg-science-animation-85"
                      x="90.86"
                      y="0"
                    >o</tspan><tspan
                      x="101.11"
                      y="0"
                    >w initiation of se</tspan><tspan
                      class="bmg-science-animation-86"
                      x="238.26"
                      y="0"
                    >c</tspan><tspan
                      x="247.55"
                      y="0"
                    >o</tspan><tspan
                      class="bmg-science-animation-81"
                      x="258.06"
                      y="0"
                    >n</tspan><tspan
                      class="bmg-science-animation-83"
                      x="269.44"
                      y="0"
                    >da</tspan><tspan
                      class="bmg-science-animation-87"
                      x="290.69"
                      y="0"
                    >r</tspan><tspan
                      x="297.66"
                      y="0"
                    >y</tspan></text>
                    <text
                      id="_02Text_04"
                      data-name="02Text_04"
                      class="bmg-science-animation-80"
                      transform="translate(35.37 139.59)"
                    >Gap wideni<tspan
                      class="bmg-science-animation-81"
                      x="95.18"
                      y="0"
                    >n</tspan><tspan
                      class="bmg-science-animation-83"
                      x="106.56"
                      y="0"
                    >g a</tspan><tspan
                      class="bmg-science-animation-81"
                      x="132.34"
                      y="0"
                    >n</tspan><tspan
                      x="143.72"
                      y="0"
                    >d </tspan><tspan
                      class="bmg-science-animation-86"
                      x="159.47"
                      y="0"
                    >c</tspan><tspan
                      x="168.76"
                      y="0"
                    >o</tspan><tspan
                      class="bmg-science-animation-81"
                      x="179.27"
                      y="0"
                    >n</tspan><tspan
                      class="bmg-science-animation-88"
                      x="190.65"
                      y="0"
                    >c</tspan><tspan
                      x="199.93"
                      y="0"
                    >omitant dec</tspan><tspan
                      class="bmg-science-animation-89"
                      x="302.89"
                      y="0"
                    >r</tspan><tspan
                      class="bmg-science-animation-85"
                      x="309.39"
                      y="0"
                    >e</tspan><tspan
                      x="319.27"
                      y="0"
                    >ase </tspan></text>
                    <text
                      id="_02Text_03"
                      data-name="02Text_03"
                      class="bmg-science-animation-80"
                      transform="translate(45.37 118.25)"
                    >e<tspan
                      class="bmg-science-animation-81"
                      x="10.12"
                      y="0"
                    >n</tspan><tspan
                      x="21.5"
                      y="0"
                    >ds of t</tspan><tspan
                      class="bmg-science-animation-81"
                      x="72.84"
                      y="0"
                    >h</tspan><tspan
                      x="84.22"
                      y="0"
                    >e </tspan><tspan
                      class="bmg-science-animation-90"
                      x="98.73"
                      y="0"
                    >f</tspan><tspan
                      class="bmg-science-animation-86"
                      x="105.76"
                      y="0"
                    >r</tspan><tspan
                      class="bmg-science-animation-81"
                      x="112.33"
                      y="0"
                    >a</tspan><tspan
                      class="bmg-science-animation-91"
                      x="122.25"
                      y="0"
                    >c</tspan><tspan
                      x="131.79"
                      y="0"
                    >tu</tspan><tspan
                      class="bmg-science-animation-92"
                      x="149.87"
                      y="0"
                    >r</tspan><tspan
                      x="156.37"
                      y="0"
                    >e </tspan><tspan
                      class="bmg-science-animation-90"
                      x="170.89"
                      y="0"
                    >f</tspan><tspan
                      class="bmg-science-animation-86"
                      x="177.91"
                      y="0"
                    >r</tspan><tspan
                      class="bmg-science-animation-81"
                      x="184.48"
                      y="0"
                    >a</tspan><tspan
                      class="bmg-science-animation-83"
                      x="194.4"
                      y="0"
                    >g</tspan><tspan
                      class="bmg-science-animation-93"
                      x="205.9"
                      y="0"
                    >m</tspan><tspan
                      x="223.71"
                      y="0"
                    >ents</tspan></text>
                    <text
                      id="_02Text_02"
                      data-name="02Text_02"
                      class="bmg-science-animation-80"
                      transform="translate(35.37 75.57)"
                    ><tspan class="bmg-science-animation-94">T</tspan><tspan
                      x="8.7"
                      y="0"
                    >o dec</tspan><tspan
                      class="bmg-science-animation-92"
                      x="54.52"
                      y="0"
                    >r</tspan><tspan
                      class="bmg-science-animation-85"
                      x="61.02"
                      y="0"
                    >e</tspan><tspan
                      x="70.9"
                      y="0"
                    >ase st</tspan><tspan
                      class="bmg-science-animation-86"
                      x="118.5"
                      y="0"
                    >r</tspan><tspan
                      x="125.07"
                      y="0"
                    >ain at t</tspan><tspan
                      class="bmg-science-animation-81"
                      x="183.09"
                      y="0"
                    >h</tspan><tspan
                      x="194.47"
                      y="0"
                    >e </tspan><tspan
                      class="bmg-science-animation-95"
                      x="208.98"
                      y="0"
                    >f</tspan><tspan
                      class="bmg-science-animation-84"
                      x="216.01"
                      y="0"
                    >r</tspan><tspan
                      class="bmg-science-animation-93"
                      x="222.58"
                      y="0"
                    >a</tspan><tspan
                      class="bmg-science-animation-96"
                      x="232.5"
                      y="0"
                    >c</tspan><tspan
                      x="242.03"
                      y="0"
                    >tu</tspan><tspan
                      class="bmg-science-animation-92"
                      x="260.12"
                      y="0"
                    >r</tspan><tspan
                      x="266.62"
                      y="0"
                    >e si</tspan><tspan
                      class="bmg-science-animation-97"
                      x="293.84"
                      y="0"
                    >t</tspan><tspan
                      x="300.33"
                      y="0"
                    >e, t</tspan><tspan
                      class="bmg-science-animation-81"
                      x="325.2"
                      y="0"
                    >h</tspan><tspan
                      x="336.58"
                      y="0"
                    >e</tspan></text>
                    <text
                      id="_02Text_01"
                      data-name="02Text_01"
                      class="bmg-science-animation-80"
                      transform="translate(35.37 32.89)"
                    >St<tspan
                      class="bmg-science-animation-86"
                      x="17.11"
                      y="0"
                    >r</tspan><tspan
                      class="bmg-science-animation-98"
                      x="23.68"
                      y="0"
                    >ains </tspan><tspan
                      class="bmg-science-animation-82"
                      x="62.01"
                      y="0"
                    >e</tspan><tspan
                      class="bmg-science-animation-97"
                      x="71.88"
                      y="0"
                    >x</tspan><tspan
                      class="bmg-science-animation-86"
                      x="80.52"
                      y="0"
                    >c</tspan><tspan
                      x="89.8"
                      y="0"
                    >eedi</tspan><tspan
                      class="bmg-science-animation-81"
                      x="125.92"
                      y="0"
                    >n</tspan><tspan
                      class="bmg-science-animation-83"
                      x="137.3"
                      y="0"
                    >g </tspan><tspan
                      class="bmg-science-animation-99"
                      x="153.19"
                      y="0"
                    >2</tspan><tspan
                      class="bmg-science-animation-100"
                      x="162.88"
                      y="0"
                    >%</tspan><tspan
                      x="177.27"
                      y="0"
                    >, p</tspan><tspan
                      class="bmg-science-animation-92"
                      x="196.58"
                      y="0"
                    >r</tspan><tspan
                      x="203.08"
                      y="0"
                    >esent in t</tspan><tspan
                      class="bmg-science-animation-81"
                      x="281.12"
                      y="0"
                    >h</tspan><tspan
                      x="292.5"
                      y="0"
                    >e </tspan><tspan
                      class="bmg-science-animation-90"
                      x="307.01"
                      y="0"
                    >f</tspan><tspan
                      class="bmg-science-animation-86"
                      x="314.04"
                      y="0"
                    >r</tspan><tspan
                      class="bmg-science-animation-81"
                      x="320.61"
                      y="0"
                    >a</tspan><tspan
                      class="bmg-science-animation-91"
                      x="330.53"
                      y="0"
                    >c</tspan><tspan
                      x="340.06"
                      y="0"
                    >tu</tspan><tspan
                      class="bmg-science-animation-92"
                      x="358.15"
                      y="0"
                    >r</tspan><tspan
                      x="364.65"
                      y="0"
                    >e</tspan></text>
                    <text
                      id="_02Text_03-2"
                      data-name="02Text_03"
                      class="bmg-science-animation-80"
                      transform="translate(45.17 54.23)"
                    >ga<tspan
                      class="bmg-science-animation-82"
                      x="21.39"
                      y="0"
                    >p</tspan><tspan
                      x="32.5"
                      y="0"
                    >, in</tspan><tspan
                      class="bmg-science-animation-97"
                      x="56.3"
                      y="0"
                    >t</tspan><tspan
                      x="62.78"
                      y="0"
                    >er</tspan><tspan
                      class="bmg-science-animation-84"
                      x="79.63"
                      y="0"
                    >f</tspan><tspan
                      x="85.16"
                      y="0"
                    >e</tspan><tspan
                      class="bmg-science-animation-89"
                      x="95.28"
                      y="0"
                    >r</tspan><tspan
                      x="101.79"
                      y="0"
                    >e with p</tspan><tspan
                      class="bmg-science-animation-101"
                      x="169.45"
                      y="0"
                    >r</tspan><tspan
                      x="176.03"
                      y="0"
                    >ima</tspan><tspan
                      class="bmg-science-animation-87"
                      x="208.21"
                      y="0"
                    >r</tspan><tspan
                      x="215.18"
                      y="0"
                    >y bo</tspan><tspan
                      class="bmg-science-animation-93"
                      x="250.53"
                      y="0"
                    >n</tspan><tspan
                      x="261.91"
                      y="0"
                    >e </tspan><tspan
                      class="bmg-science-animation-81"
                      x="276.43"
                      y="0"
                    >h</tspan><tspan
                      class="bmg-science-animation-82"
                      x="287.81"
                      y="0"
                    >e</tspan><tspan
                      x="297.68"
                      y="0"
                    >ali</tspan><tspan
                      class="bmg-science-animation-93"
                      x="316.58"
                      y="0"
                    >n</tspan><tspan
                      x="327.96"
                      y="0"
                    >g</tspan></text>
                    <text
                      id="_02Text_03-3"
                      data-name="02Text_03"
                      class="bmg-science-animation-80"
                      transform="translate(45.17 96.91)"
                    >body <tspan
                      class="bmg-science-animation-92"
                      x="46.71"
                      y="0"
                    >r</tspan><tspan
                      x="53.21"
                      y="0"
                    >espo</tspan><tspan
                      class="bmg-science-animation-81"
                      x="93.41"
                      y="0"
                    >n</tspan><tspan
                      x="104.79"
                      y="0"
                    >ds </tspan><tspan
                      class="bmg-science-animation-82"
                      x="128.74"
                      y="0"
                    >b</tspan><tspan
                      x="139.85"
                      y="0"
                    >y </tspan><tspan
                      class="bmg-science-animation-92"
                      x="153.32"
                      y="0"
                    >r</tspan><tspan
                      x="159.83"
                      y="0"
                    >eso</tspan><tspan
                      class="bmg-science-animation-101"
                      x="188.65"
                      y="0"
                    >r</tspan><tspan
                      x="195.24"
                      y="0"
                    >bi</tspan><tspan
                      class="bmg-science-animation-81"
                      x="211.11"
                      y="0"
                    >n</tspan><tspan
                      class="bmg-science-animation-83"
                      x="222.49"
                      y="0"
                    >g bo</tspan><tspan
                      class="bmg-science-animation-81"
                      x="260.25"
                      y="0"
                    >n</tspan><tspan
                      x="271.63"
                      y="0"
                    >e at t</tspan><tspan
                      class="bmg-science-animation-81"
                      x="314.04"
                      y="0"
                    >h</tspan><tspan
                      x="325.42"
                      y="0"
                    >e</tspan></text>
                  </g>
                  <g
                    id="_02CheckMarks"
                    data-name="02CheckMarks"
                  >
                    <g
                      id="_02CheckMarks_03"
                      data-name="02CheckMarks_03"
                    >
                      <line
                        class="bmg-science-animation-102"
                        x1="10.94"
                        y1="136.84"
                        x2="15.82"
                        y2="140.45"
                      />
                      <line
                        class="bmg-science-animation-103"
                        x1="25.37"
                        y1="128.35"
                        x2="15.82"
                        y2="140.45"
                      />
                    </g>
                    <g
                      id="_02CheckMarks_02"
                      data-name="02CheckMarks_02"
                    >
                      <line
                        class="bmg-science-animation-102"
                        x1="10.94"
                        y1="72.09"
                        x2="15.82"
                        y2="75.7"
                      />
                      <line
                        class="bmg-science-animation-103"
                        x1="25.37"
                        y1="63.6"
                        x2="15.82"
                        y2="75.7"
                      />
                    </g>
                    <g
                      id="_02CheckMarks_01"
                      data-name="02CheckMarks_01"
                    >
                      <line
                        class="bmg-science-animation-102"
                        x1="10.94"
                        y1="30.21"
                        x2="15.82"
                        y2="33.82"
                      />
                      <line
                        class="bmg-science-animation-103"
                        x1="25.37"
                        y1="21.72"
                        x2="15.82"
                        y2="33.82"
                      />
                    </g>
                  </g>
                </g>
              </g>
              <g id="_01Sequence">
                <g id="ConventionalFixation_Label">
                  <text
                    id="ConventionalFixation_Label_Text"
                    class="bmg-science-animation-35"
                    transform="translate(313.21 271.83)"
                  ><tspan class="bmg-science-animation-45">C</tspan><tspan
                    class="bmg-science-animation-46"
                    x="8.33"
                    y="0"
                  >o</tspan><tspan
                    class="bmg-science-animation-38"
                    x="15.84"
                    y="0"
                  >n</tspan><tspan
                    class="bmg-science-animation-39"
                    x="23.82"
                    y="0"
                  >v</tspan><tspan
                    x="30.13"
                    y="0"
                  >entional </tspan><tspan
                    class="bmg-science-animation-38"
                    x="82.58"
                    y="0"
                  >F</tspan><tspan
                    x="90.04"
                    y="0"
                  >i</tspan><tspan
                    class="bmg-science-animation-48"
                    x="93.26"
                    y="0"
                  >x</tspan><tspan
                    x="99.53"
                    y="0"
                  >ation</tspan></text>
                </g>
                <g
                  id="NecroticBone"
                  class="pointer"
                  @click="doZoom('DeadBone', 2)"
                >
                  <g id="NecroticBoneLabel">
                    <text
                      class="bmg-science-animation-29"
                      transform="translate(387.21 350.38)"
                    >Reso<tspan
                      class="bmg-science-animation-75"
                      x="30.98"
                      y="0"
                    >r</tspan><tspan
                      class="bmg-science-animation-32"
                      x="35.97"
                      y="0"
                    >bed</tspan></text>
                    <text
                      class="bmg-science-animation-29"
                      transform="translate(387.21 322.56)"
                    >Nec<tspan
                      class="bmg-science-animation-34"
                      x="25.11"
                      y="0"
                    >r</tspan><tspan
                      x="30.03"
                      y="0"
                    >otic</tspan></text>
                    <text
                      class="bmg-science-animation-29"
                      transform="translate(387.21 336.47)"
                    >Bo<tspan
                      class="bmg-science-animation-30"
                      x="17.52"
                      y="0"
                    >n</tspan><tspan
                      x="26.13"
                      y="0"
                    >e</tspan></text>
                  </g>
                  <image
                    class="animation-google-tracking"
                    tracking-info="Zoom to Necrotic Bone"
                    id="NecroticBonePic"
                    width="490"
                    height="486"
                    transform="translate(301.64 293.59) scale(0.16 0.16)"
                    :xlink:href="require('../assets/medical_pics/NecroticBone.png')"
                  />
                </g>
                <g
                  id="InternalFixation"
                  class="pointer"
                  @click="doZoom('InternalFixation', 2)"
                >
                  <text
                    id="InternalFixation_Label"
                    class="bmg-science-animation-35"
                    transform="translate(144.3 258.23)"
                  >In<tspan
                    class="bmg-science-animation-73"
                    x="11.72"
                    y="0"
                  >t</tspan><tspan
                    class="bmg-science-animation-46"
                    x="16.35"
                    y="0"
                  >e</tspan><tspan
                    class="bmg-science-animation-76"
                    x="23.58"
                    y="0"
                  >r</tspan><tspan
                    x="28.29"
                    y="0"
                  >nal </tspan><tspan
                    class="bmg-science-animation-38"
                    x="49.81"
                    y="0"
                  >F</tspan><tspan
                    x="57.27"
                    y="0"
                  >i</tspan><tspan
                    class="bmg-science-animation-48"
                    x="60.49"
                    y="0"
                  >x</tspan><tspan
                    x="66.77"
                    y="0"
                  >ation Su</tspan><tspan
                    class="bmg-science-animation-47"
                    x="116.08"
                    y="0"
                  >r</tspan><tspan
                    class="bmg-science-animation-41"
                    x="120.72"
                    y="0"
                  >ge</tspan><tspan
                    class="bmg-science-animation-77"
                    x="136.17"
                    y="0"
                  >r</tspan><tspan
                    class="bmg-science-animation-46"
                    x="141.14"
                    y="0"
                  >y</tspan><tspan
                    x="-3.95"
                    y="14.37"
                  >(</tspan><tspan
                    class="bmg-science-animation-61"
                    x="-0.01"
                    y="14.37"
                  >W</tspan><tspan
                    x="13.08"
                    y="14.37"
                  >ith Desc</tspan><tspan
                    class="bmg-science-animation-78"
                    x="62.11"
                    y="14.37"
                  >r</tspan><tspan
                    x="66.82"
                    y="14.37"
                  >iption of Bo</tspan><tspan
                    class="bmg-science-animation-43"
                    x="136.22"
                    y="14.37"
                  >n</tspan><tspan
                    x="144.35"
                    y="14.37"
                  >e</tspan><tspan
                    x="18.09"
                    y="28.73"
                  >R</tspan><tspan
                    class="bmg-science-animation-39"
                    x="26.74"
                    y="28.73"
                  >e</tspan><tspan
                    class="bmg-science-animation-42"
                    x="33.8"
                    y="28.73"
                  >a</tspan><tspan
                    class="bmg-science-animation-79"
                    x="40.88"
                    y="28.73"
                  >c</tspan><tspan
                    x="47.69"
                    y="28.73"
                  >tion </tspan><tspan
                    class="bmg-science-animation-58"
                    x="74.52"
                    y="28.73"
                  >t</tspan><tspan
                    x="79.16"
                    y="28.73"
                  >o St</tspan><tspan
                    class="bmg-science-animation-47"
                    x="102.02"
                    y="28.73"
                  >r</tspan><tspan
                    x="106.67"
                    y="28.73"
                  >ess)</tspan></text>
                  <image
                    class="animation-google-tracking"
                    tracking-info="Zoom to Internal Fixation"
                    width="2314"
                    height="1744"
                    transform="translate(165.6 293) scale(0.05)"
                    :xlink:href="require('../assets/animations/FullAnimation2.png')"
                  />
                </g>
                <g
                  id="BoneFracture"
                  class="pointer"
                  @click="doZoom('BoneFractures', 1)"
                >
                  <text
                    id="BoneFracture_Label"
                    class="bmg-science-animation-35"
                    transform="translate(33.53 386.09)"
                  >Bo<tspan
                    class="bmg-science-animation-42"
                    x="16.53"
                    y="0"
                  >n</tspan><tspan
                    class="bmg-science-animation-46"
                    x="24.66"
                    y="0"
                  >e </tspan><tspan
                    class="bmg-science-animation-38"
                    x="35.03"
                    y="0"
                  >F</tspan><tspan
                    class="bmg-science-animation-59"
                    x="42.49"
                    y="0"
                  >r</tspan><tspan
                    class="bmg-science-animation-42"
                    x="47.18"
                    y="0"
                  >a</tspan><tspan
                    class="bmg-science-animation-79"
                    x="54.27"
                    y="0"
                  >c</tspan><tspan
                    x="61.08"
                    y="0"
                  >tu</tspan><tspan
                    class="bmg-science-animation-47"
                    x="74"
                    y="0"
                  >r</tspan><tspan
                    x="78.64"
                    y="0"
                  >e</tspan><tspan
                    x="21.9"
                    y="14.37"
                  >O</tspan><tspan
                    class="bmg-science-animation-59"
                    x="31.94"
                    y="14.37"
                  >c</tspan><tspan
                    class="bmg-science-animation-41"
                    x="38.57"
                    y="14.37"
                  >cu</tspan><tspan
                    class="bmg-science-animation-55"
                    x="53.37"
                    y="14.37"
                  >r</tspan><tspan
                    x="58.12"
                    y="14.37"
                  >s</tspan></text>
                  <image
                    class="animation-google-tracking"
                    tracking-info="Zoom to Bone Fractures"
                    id="BoneFracture_Pic"
                    width="800"
                    height="627"
                    transform="translate(25.94 291.48) scale(0.13 0.13)"
                    :xlink:href="require('../assets/animations/FullAnimation1.jpg')"
                  />
                </g>
                <g
                  id="_01Explanation"
                  data-name="01Explanation"
                >
                  <g
                    id="_01Text"
                    data-name="01Text"
                  >
                    <text
                      id="_01Text_04"
                      data-name="01Text_04"
                      class="bmg-science-animation-80"
                      transform="translate(36.42 94.46)"
                    >BMG Quantified t<tspan
                      class="bmg-science-animation-81"
                      x="148.09"
                      y="0"
                    >h</tspan><tspan
                      x="159.47"
                      y="0"
                    >e </tspan><tspan
                      class="bmg-science-animation-92"
                      x="173.99"
                      y="0"
                    >r</tspan><tspan
                      class="bmg-science-animation-83"
                      x="180.49"
                      y="0"
                    >esu</tspan><tspan
                      class="bmg-science-animation-81"
                      x="210.09"
                      y="0"
                    >l</tspan><tspan
                      x="214.63"
                      y="0"
                    >ti</tspan><tspan
                      class="bmg-science-animation-81"
                      x="225.94"
                      y="0"
                    >n</tspan><tspan
                      class="bmg-science-animation-83"
                      x="237.32"
                      y="0"
                    >g gaps</tspan></text>
                    <text
                      id="_01Text_03"
                      data-name="01Text_03"
                      class="bmg-science-animation-80"
                      transform="translate(35.37 74)"
                    >D<tspan
                      class="bmg-science-animation-104"
                      x="13.84"
                      y="0"
                    >e</tspan><tspan
                      class="bmg-science-animation-85"
                      x="23.8"
                      y="0"
                    >v</tspan><tspan
                      x="32.63"
                      y="0"
                    >elopi</tspan><tspan
                      class="bmg-science-animation-81"
                      x="73.64"
                      y="0"
                    >n</tspan><tspan
                      class="bmg-science-animation-83"
                      x="85.02"
                      y="0"
                    >g gaps l</tspan><tspan
                      class="bmg-science-animation-85"
                      x="150.76"
                      y="0"
                    >e</tspan><tspan
                      class="bmg-science-animation-93"
                      x="160.63"
                      y="0"
                    >a</tspan><tspan
                      x="170.55"
                      y="0"
                    >d </tspan><tspan
                      class="bmg-science-animation-97"
                      x="186.31"
                      y="0"
                    >t</tspan><tspan
                      x="192.79"
                      y="0"
                    >o los of </tspan><tspan
                      class="bmg-science-animation-101"
                      x="255.88"
                      y="0"
                    >r</tspan><tspan
                      class="bmg-science-animation-98"
                      x="262.47"
                      y="0"
                    >igid fi</tspan><tspan
                      class="bmg-science-animation-105"
                      x="310.27"
                      y="0"
                    >x</tspan><tspan
                      x="319.05"
                      y="0"
                    >ation</tspan></text>
                    <text
                      id="_01Text_02"
                      data-name="01Text_02"
                      class="bmg-science-animation-80"
                      transform="translate(35.37 53.64)"
                    >Os<tspan
                      class="bmg-science-animation-97"
                      x="22.26"
                      y="0"
                    >t</tspan><tspan
                      x="28.74"
                      y="0"
                    >eo</tspan><tspan
                      class="bmg-science-animation-101"
                      x="49.38"
                      y="0"
                    >c</tspan><tspan
                      x="58.68"
                      y="0"
                    >lastic </tspan><tspan
                      class="bmg-science-animation-92"
                      x="106.41"
                      y="0"
                    >r</tspan><tspan
                      x="112.91"
                      y="0"
                    >eso</tspan><tspan
                      class="bmg-science-animation-101"
                      x="141.74"
                      y="0"
                    >r</tspan><tspan
                      x="148.33"
                      y="0"
                    >ption </tspan><tspan
                      class="bmg-science-animation-89"
                      x="197.25"
                      y="0"
                    >r</tspan><tspan
                      x="203.75"
                      y="0"
                    >e</tspan><tspan
                      class="bmg-science-animation-81"
                      x="213.88"
                      y="0"
                    >m</tspan><tspan
                      class="bmg-science-animation-82"
                      x="231.69"
                      y="0"
                    >ov</tspan><tspan
                      x="250.78"
                      y="0"
                    >es t</tspan><tspan
                      class="bmg-science-animation-81"
                      x="280.3"
                      y="0"
                    >h</tspan><tspan
                      x="291.68"
                      y="0"
                    >e </tspan><tspan
                      class="bmg-science-animation-93"
                      x="306.19"
                      y="0"
                    >n</tspan><tspan
                      x="317.57"
                      y="0"
                    >ec</tspan><tspan
                      class="bmg-science-animation-92"
                      x="337.13"
                      y="0"
                    >r</tspan><tspan
                      x="343.63"
                      y="0"
                    >otic bo</tspan><tspan
                      class="bmg-science-animation-81"
                      x="401.16"
                      y="0"
                    >n</tspan><tspan
                      x="412.54"
                      y="0"
                    >e</tspan></text>
                    <text
                      id="_01Text_01"
                      data-name="01Text_01"
                      class="bmg-science-animation-80"
                      transform="translate(35.37 32.89)"
                    >Bo<tspan
                      class="bmg-science-animation-81"
                      x="23.15"
                      y="0"
                    >n</tspan><tspan
                      x="34.53"
                      y="0"
                    >e dies on eit</tspan><tspan
                      class="bmg-science-animation-81"
                      x="135.31"
                      y="0"
                    >h</tspan><tspan
                      x="146.69"
                      y="0"
                    >er side of a bo</tspan><tspan
                      class="bmg-science-animation-81"
                      x="263.24"
                      y="0"
                    >n</tspan><tspan
                      x="274.62"
                      y="0"
                    >e </tspan><tspan
                      class="bmg-science-animation-95"
                      x="289.13"
                      y="0"
                    >f</tspan><tspan
                      class="bmg-science-animation-86"
                      x="296.15"
                      y="0"
                    >r</tspan><tspan
                      class="bmg-science-animation-81"
                      x="302.72"
                      y="0"
                    >a</tspan><tspan
                      class="bmg-science-animation-96"
                      x="312.64"
                      y="0"
                    >c</tspan><tspan
                      x="322.18"
                      y="0"
                    >tu</tspan><tspan
                      class="bmg-science-animation-92"
                      x="340.27"
                      y="0"
                    >r</tspan><tspan
                      x="346.77"
                      y="0"
                    >e</tspan></text>
                  </g>
                  <g
                    id="_01CheckMarks"
                    data-name="01CheckMarks"
                  >
                    <g
                      id="_01CheckMarks_04"
                      data-name="01CheckMarks_04"
                    >
                      <line
                        class="bmg-science-animation-102"
                        x1="12.94"
                        y1="92.84"
                        x2="17.82"
                        y2="96.45"
                      />
                      <line
                        class="bmg-science-animation-103"
                        x1="27.37"
                        y1="84.35"
                        x2="17.82"
                        y2="96.45"
                      />
                    </g>
                    <g
                      id="_01CheckMarks_03"
                      data-name="01CheckMarks_03"
                    >
                      <line
                        class="bmg-science-animation-102"
                        x1="12.94"
                        y1="71.96"
                        x2="17.82"
                        y2="75.57"
                      />
                      <line
                        class="bmg-science-animation-103"
                        x1="27.37"
                        y1="63.47"
                        x2="17.82"
                        y2="75.57"
                      />
                    </g>
                    <g
                      id="_01CheckMarks_02"
                      data-name="01CheckMarks_02"
                    >
                      <line
                        class="bmg-science-animation-102"
                        x1="12.94"
                        y1="51.09"
                        x2="17.82"
                        y2="54.7"
                      />
                      <line
                        class="bmg-science-animation-103"
                        x1="27.37"
                        y1="42.6"
                        x2="17.82"
                        y2="54.7"
                      />
                    </g>
                    <g
                      id="_01CheckMarks_01"
                      data-name="01CheckMarks_01"
                    >
                      <line
                        class="bmg-science-animation-102"
                        x1="12.94"
                        y1="30.21"
                        x2="17.82"
                        y2="33.82"
                      />
                      <line
                        class="bmg-science-animation-103"
                        x1="27.37"
                        y1="21.72"
                        x2="17.82"
                        y2="33.82"
                      />
                    </g>
                  </g>
                </g>
              </g>
            </g>
            <g id="StartExplanation">
              <g id="StartText">
                <text
                  id="StartText_06"
                  class="bmg-science-animation-80"
                  transform="translate(43.37 133.93)"
                ><tspan class="bmg-science-animation-82">e</tspan><tspan
                  x="9.87"
                  y="0"
                >a</tspan><tspan
                  class="bmg-science-animation-106"
                  x="19.76"
                  y="0"
                >r</tspan><tspan
                  x="26.35"
                  y="0"
                >ly </tspan><tspan
                  class="bmg-science-animation-85"
                  x="44.33"
                  y="0"
                >w</tspan><tspan
                  x="58.81"
                  y="0"
                >eight b</tspan><tspan
                  class="bmg-science-animation-82"
                  x="118.85"
                  y="0"
                >e</tspan><tspan
                  x="128.72"
                  y="0"
                >a</tspan><tspan
                  class="bmg-science-animation-106"
                  x="138.61"
                  y="0"
                >r</tspan><tspan
                  x="145.19"
                  y="0"
                >i</tspan><tspan
                  class="bmg-science-animation-81"
                  x="149.7"
                  y="0"
                >n</tspan><tspan
                  class="bmg-science-animation-83"
                  x="161.08"
                  y="0"
                >g a</tspan><tspan
                  class="bmg-science-animation-81"
                  x="186.86"
                  y="0"
                >n</tspan><tspan
                  class="bmg-science-animation-83"
                  x="198.24"
                  y="0"
                >d </tspan><tspan
                  class="bmg-science-animation-82"
                  x="213.99"
                  y="0"
                >e</tspan><tspan
                  class="bmg-science-animation-97"
                  x="223.87"
                  y="0"
                >x</tspan><tspan
                  x="232.5"
                  y="0"
                >e</tspan><tspan
                  class="bmg-science-animation-92"
                  x="242.62"
                  y="0"
                >r</tspan><tspan
                  x="249.12"
                  y="0"
                >cise</tspan></text>
                <text
                  id="StartText_05"
                  class="bmg-science-animation-80"
                  transform="translate(43.37 113.93)"
                >sustai<tspan
                  class="bmg-science-animation-81"
                  x="48.87"
                  y="0"
                >n</tspan><tspan
                  x="60.25"
                  y="0"
                >ed, </tspan><tspan
                  class="bmg-science-animation-101"
                  x="89.68"
                  y="0"
                >r</tspan><tspan
                  x="96.27"
                  y="0"
                >igid fi</tspan><tspan
                  class="bmg-science-animation-104"
                  x="144.07"
                  y="0"
                >x</tspan><tspan
                  x="152.85"
                  y="0"
                >ation, a</tspan><tspan
                  class="bmg-science-animation-81"
                  x="213.74"
                  y="0"
                >n</tspan><tspan
                  x="225.12"
                  y="0"
                >d </tspan><tspan
                  class="bmg-science-animation-105"
                  x="240.88"
                  y="0"
                >f</tspan><tspan
                  class="bmg-science-animation-93"
                  x="246.39"
                  y="0"
                >a</tspan><tspan
                  x="256.31"
                  y="0"
                >cilita</tspan><tspan
                  class="bmg-science-animation-97"
                  x="295.97"
                  y="0"
                >t</tspan><tspan
                  x="302.46"
                  y="0"
                >es</tspan></text>
                <text
                  id="StartText_04"
                  class="bmg-science-animation-80"
                  transform="translate(43.37 94.46)"
                >p<tspan
                  class="bmg-science-animation-92"
                  x="11.36"
                  y="0"
                >r</tspan><tspan
                  x="17.87"
                  y="0"
                >o</tspan><tspan
                  class="bmg-science-animation-93"
                  x="28.38"
                  y="0"
                >m</tspan><tspan
                  x="46.19"
                  y="0"
                >o</tspan><tspan
                  class="bmg-science-animation-97"
                  x="56.7"
                  y="0"
                >t</tspan><tspan
                  x="63.19"
                  y="0"
                >es p</tspan><tspan
                  class="bmg-science-animation-101"
                  x="97.26"
                  y="0"
                >r</tspan><tspan
                  x="103.85"
                  y="0"
                >ima</tspan><tspan
                  class="bmg-science-animation-87"
                  x="136.03"
                  y="0"
                >r</tspan><tspan
                  x="143"
                  y="0"
                >y bo</tspan><tspan
                  class="bmg-science-animation-93"
                  x="178.35"
                  y="0"
                >n</tspan><tspan
                  x="189.73"
                  y="0"
                >e </tspan><tspan
                  class="bmg-science-animation-81"
                  x="204.24"
                  y="0"
                >h</tspan><tspan
                  class="bmg-science-animation-82"
                  x="215.62"
                  y="0"
                >e</tspan><tspan
                  x="225.49"
                  y="0"
                >ali</tspan><tspan
                  class="bmg-science-animation-93"
                  x="244.4"
                  y="0"
                >n</tspan><tspan
                  x="255.78"
                  y="0"
                >g th</tspan><tspan
                  class="bmg-science-animation-89"
                  x="289.82"
                  y="0"
                >r</tspan><tspan
                  x="296.32"
                  y="0"
                >ough</tspan></text>
                <text
                  id="StartText_03"
                  class="bmg-science-animation-80"
                  transform="translate(35.37 74)"
                >H<tspan
                  class="bmg-science-animation-82"
                  x="13.63"
                  y="0"
                >o</tspan><tspan
                  x="23.88"
                  y="0"
                >w BMG&apos;s </tspan><tspan
                  class="bmg-science-animation-93"
                  x="100.58"
                  y="0"
                >n</tspan><tspan
                  class="bmg-science-animation-85"
                  x="111.96"
                  y="0"
                >e</tspan><tspan
                  x="121.83"
                  y="0"
                >xt ge</tspan><tspan
                  class="bmg-science-animation-81"
                  x="163.6"
                  y="0"
                >n</tspan><tspan
                  x="174.98"
                  y="0"
                >e</tspan><tspan
                  class="bmg-science-animation-86"
                  x="185.1"
                  y="0"
                >r</tspan><tspan
                  x="191.67"
                  y="0"
                >ation ha</tspan><tspan
                  class="bmg-science-animation-92"
                  x="260.35"
                  y="0"
                >r</tspan><tspan
                  x="266.86"
                  y="0"
                >d</tspan><tspan
                  class="bmg-science-animation-107"
                  x="278.22"
                  y="0"
                >w</tspan><tspan
                  x="292.68"
                  y="0"
                >a</tspan><tspan
                  class="bmg-science-animation-92"
                  x="302.57"
                  y="0"
                >r</tspan><tspan
                  x="309.08"
                  y="0"
                >e</tspan></text>
                <text
                  id="StartText_02"
                  class="bmg-science-animation-80"
                  transform="translate(43.37 53.64)"
                >causi<tspan
                  class="bmg-science-animation-81"
                  x="43.31"
                  y="0"
                >n</tspan><tspan
                  class="bmg-science-animation-83"
                  x="54.69"
                  y="0"
                >g bo</tspan><tspan
                  class="bmg-science-animation-93"
                  x="92.45"
                  y="0"
                >n</tspan><tspan
                  x="103.83"
                  y="0"
                >e </tspan><tspan
                  class="bmg-science-animation-97"
                  x="118.34"
                  y="0"
                >t</tspan><tspan
                  x="124.83"
                  y="0"
                >o de</tspan><tspan
                  class="bmg-science-animation-105"
                  x="161.22"
                  y="0"
                >f</tspan><tspan
                  x="166.73"
                  y="0"
                >au</tspan><tspan
                  class="bmg-science-animation-81"
                  x="187.9"
                  y="0"
                >l</tspan><tspan
                  x="192.44"
                  y="0"
                >t in</tspan><tspan
                  class="bmg-science-animation-108"
                  x="219.49"
                  y="0"
                >t</tspan><tspan
                  x="225.98"
                  y="0"
                >o se</tspan><tspan
                  class="bmg-science-animation-86"
                  x="259.2"
                  y="0"
                >c</tspan><tspan
                  x="268.48"
                  y="0"
                >o</tspan><tspan
                  class="bmg-science-animation-81"
                  x="278.99"
                  y="0"
                >n</tspan><tspan
                  x="290.37"
                  y="0"
                >da</tspan><tspan
                  class="bmg-science-animation-109"
                  x="311.62"
                  y="0"
                >r</tspan><tspan
                  x="318.59"
                  y="0"
                >y </tspan><tspan
                  class="bmg-science-animation-81"
                  x="332.07"
                  y="0"
                >h</tspan><tspan
                  class="bmg-science-animation-82"
                  x="343.45"
                  y="0"
                >e</tspan><tspan
                  x="353.32"
                  y="0"
                >ali</tspan><tspan
                  class="bmg-science-animation-81"
                  x="372.23"
                  y="0"
                >n</tspan><tspan
                  class="bmg-science-animation-83"
                  x="383.61"
                  y="0"
                >g</tspan></text>
                <text
                  id="StartText_01"
                  class="bmg-science-animation-80"
                  transform="translate(35.37 32.89)"
                >W<tspan
                  class="bmg-science-animation-105"
                  x="18.62"
                  y="0"
                >h</tspan><tspan
                  x="29.8"
                  y="0"
                >y </tspan><tspan
                  class="bmg-science-animation-86"
                  x="43.28"
                  y="0"
                >c</tspan><tspan
                  x="52.56"
                  y="0"
                >o</tspan><tspan
                  class="bmg-science-animation-105"
                  x="63.07"
                  y="0"
                >n</tspan><tspan
                  class="bmg-science-animation-82"
                  x="74.25"
                  y="0"
                >v</tspan><tspan
                  x="83.08"
                  y="0"
                >entional in</tspan><tspan
                  class="bmg-science-animation-97"
                  x="172.36"
                  y="0"
                >t</tspan><tspan
                  x="178.85"
                  y="0"
                >e</tspan><tspan
                  class="bmg-science-animation-101"
                  x="188.97"
                  y="0"
                >r</tspan><tspan
                  x="195.56"
                  y="0"
                >nal fi</tspan><tspan
                  class="bmg-science-animation-105"
                  x="237.22"
                  y="0"
                >x</tspan><tspan
                  x="246.01"
                  y="0"
                >ation ha</tspan><tspan
                  class="bmg-science-animation-92"
                  x="314.69"
                  y="0"
                >r</tspan><tspan
                  x="321.19"
                  y="0"
                >d</tspan><tspan
                  class="bmg-science-animation-107"
                  x="332.56"
                  y="0"
                >w</tspan><tspan
                  x="347.02"
                  y="0"
                >a</tspan><tspan
                  class="bmg-science-animation-92"
                  x="356.91"
                  y="0"
                >r</tspan><tspan
                  x="363.41"
                  y="0"
                >e loosens </tspan></text>
              </g>
              <g id="StartCheckMarks">
                <g id="StartCheckMarks_02">
                  <line
                    class="bmg-science-animation-102"
                    x1="12.94"
                    y1="71.96"
                    x2="17.82"
                    y2="75.57"
                  />
                  <line
                    class="bmg-science-animation-103"
                    x1="27.37"
                    y1="63.47"
                    x2="17.82"
                    y2="75.57"
                  />
                </g>
                <g id="StartCheckMarks_01">
                  <line
                    class="bmg-science-animation-102"
                    x1="12.94"
                    y1="30.21"
                    x2="17.82"
                    y2="33.82"
                  />
                  <line
                    class="bmg-science-animation-103"
                    x1="27.37"
                    y1="21.72"
                    x2="17.82"
                    y2="33.82"
                  />
                </g>
              </g>
            </g>
            <g id="ControlBarButtons">
              <g
                id="ControlButton4"
                class="pointer animation-google-tracking"
                tracking-info="Animation Audio #4 Started"
                @click="doSequenceButtonClick(4)"
              >
                <rect
                  id="Button4Background"
                  class="bmg-science-animation-110"
                  x="791"
                  y="559"
                  width="248"
                  height="30"
                />
                <g>
                  <text
                    id="Button4Text"
                    class="bmg-science-animation-111"
                    transform="translate(841.5 578.72) scale(1.01 1)"
                  ><tspan class="bmg-science-animation-112">P</tspan><tspan
                    class="bmg-science-animation-113"
                    x="8.66"
                    y="0"
                  >r</tspan><tspan
                    x="13.79"
                    y="0"
                  >ima</tspan><tspan
                    class="bmg-science-animation-114"
                    x="37.39"
                    y="0"
                  >r</tspan><tspan
                    x="42.74"
                    y="0"
                  >y H</tspan><tspan
                    class="bmg-science-animation-115"
                    x="63.01"
                    y="0"
                  >e</tspan><tspan
                    x="70.4"
                    y="0"
                  >ali</tspan><tspan
                    class="bmg-science-animation-116"
                    x="85.03"
                    y="0"
                  >n</tspan><tspan
                    x="93.4"
                    y="0"
                  >g (51)</tspan></text>
                  <g id="Speaker">
                    <path
                      class="bmg-science-animation-1"
                      d="M981,575.23v4.93c0,.4,0,.8-.45,1s-.74-.07-1-.35c-.72-.72-1.45-1.43-2.15-2.16a1.26,1.26,0,0,0-1-.42c-.77,0-1.55,0-2.33,0s-1-.27-1-1c0-1.37,0-2.74,0-4.1,0-.63.29-.91.92-.92.84,0,1.67,0,2.5,0a1.48,1.48,0,0,0,.87-.37c.76-.7,1.47-1.45,2.2-2.18.29-.28.58-.54,1-.35s.47.57.47,1Z"
                    />
                    <path
                      class="bmg-science-animation-1"
                      d="M991,575.41a8.87,8.87,0,0,1-3.74,7c-.49.36-1,.36-1.24,0s-.16-.84.35-1.22a7.32,7.32,0,0,0,.37-11.63c-.17-.14-.36-.26-.53-.41a.75.75,0,0,1-.2-1.08.72.72,0,0,1,1.09-.11,17.25,17.25,0,0,1,2.23,2.21A8.56,8.56,0,0,1,991,575.41Z"
                    />
                    <path
                      class="bmg-science-animation-1"
                      d="M988,575.3a5.89,5.89,0,0,1-2.52,4.67c-.46.32-.86.3-1.13,0s-.16-.75.21-1.12a9.71,9.71,0,0,0,1.33-1.47A4.18,4.18,0,0,0,985,572c-.17-.14-.34-.28-.5-.44a.71.71,0,0,1-.1-1,.72.72,0,0,1,1-.13,5.65,5.65,0,0,1,2.47,3.8C987.94,574.59,988,575,988,575.3Z"
                    />
                    <path
                      class="bmg-science-animation-1"
                      d="M985,575.3a2.74,2.74,0,0,1-1.27,2.21.77.77,0,0,1-1.1-.11.71.71,0,0,1,.2-1.07,1.21,1.21,0,0,0,.56-1.38,2.13,2.13,0,0,0-.55-.79c-.31-.33-.51-.65-.23-1.08s.63-.42,1.12-.13A2.79,2.79,0,0,1,985,575.3Z"
                    />
                  </g>
                </g>
              </g>
              <g
                id="ControlButton3"
                class="pointer animation-google-tracking"
                tracking-info="Animation Audio #3 Started"
                @click="doSequenceButtonClick(3)"
              >
                <rect
                  id="Button3Background"
                  class="bmg-science-animation-110"
                  x="531"
                  y="559"
                  width="248"
                  height="30"
                />
                <g>
                  <text
                    id="Button3Text"
                    class="bmg-science-animation-111"
                    transform="translate(573.33 578.72) scale(1.01 1)"
                  >Se<tspan
                    class="bmg-science-animation-117"
                    x="15.23"
                    y="0"
                  >c</tspan><tspan
                    x="22.24"
                    y="0"
                  >o</tspan><tspan
                    class="bmg-science-animation-116"
                    x="30.1"
                    y="0"
                  >n</tspan><tspan
                    x="38.46"
                    y="0"
                  >da</tspan><tspan
                    class="bmg-science-animation-114"
                    x="54.17"
                    y="0"
                  >r</tspan><tspan
                    x="59.52"
                    y="0"
                  >y H</tspan><tspan
                    class="bmg-science-animation-115"
                    x="79.79"
                    y="0"
                  >e</tspan><tspan
                    x="87.18"
                    y="0"
                  >ali</tspan><tspan
                    class="bmg-science-animation-116"
                    x="101.81"
                    y="0"
                  >n</tspan><tspan
                    x="110.17"
                    y="0"
                  >g (23)</tspan></text>
                  <g
                    id="Speaker-2"
                    data-name="Speaker"
                  >
                    <path
                      class="bmg-science-animation-1"
                      d="M731,575.23v4.93c0,.4,0,.8-.45,1s-.74-.07-1-.35c-.72-.72-1.45-1.43-2.15-2.16a1.26,1.26,0,0,0-1-.42c-.77,0-1.55,0-2.33,0s-1-.27-1-1c0-1.37,0-2.74,0-4.1,0-.63.29-.91.92-.92.84,0,1.67,0,2.5,0a1.54,1.54,0,0,0,.87-.36c.76-.71,1.47-1.46,2.2-2.19.29-.28.58-.54,1-.35s.47.57.47,1Z"
                    />
                    <path
                      class="bmg-science-animation-1"
                      d="M741,575.41a8.87,8.87,0,0,1-3.74,7c-.49.36-1,.36-1.24,0s-.16-.84.35-1.22a7.32,7.32,0,0,0,.37-11.63c-.17-.14-.36-.26-.53-.41a.75.75,0,0,1-.2-1.08.72.72,0,0,1,1.09-.11,17.25,17.25,0,0,1,2.23,2.21A8.56,8.56,0,0,1,741,575.41Z"
                    />
                    <path
                      class="bmg-science-animation-1"
                      d="M738,575.3a5.89,5.89,0,0,1-2.52,4.67c-.46.32-.86.3-1.13,0s-.16-.75.21-1.12a9.71,9.71,0,0,0,1.33-1.47A4.18,4.18,0,0,0,735,572c-.17-.14-.34-.28-.5-.44a.71.71,0,0,1-.1-1,.72.72,0,0,1,1-.13,5.65,5.65,0,0,1,2.47,3.8C737.94,574.59,738,575,738,575.3Z"
                    />
                    <path
                      class="bmg-science-animation-1"
                      d="M735,575.3a2.74,2.74,0,0,1-1.27,2.21.77.77,0,0,1-1.1-.11.71.71,0,0,1,.2-1.07,1.21,1.21,0,0,0,.56-1.38,2.13,2.13,0,0,0-.55-.79c-.31-.33-.51-.65-.23-1.08s.63-.42,1.12-.13A2.79,2.79,0,0,1,735,575.3Z"
                    />
                  </g>
                </g>
              </g>
              <g
                id="ControlButton2"
                class="pointer animation-google-tracking"
                tracking-info="Animation Audio #2 Started"
                @click="doSequenceButtonClick(2)"
              >
                <rect
                  id="Button2Background"
                  class="bmg-science-animation-110"
                  x="271"
                  y="559"
                  width="248"
                  height="30"
                />
                <g>
                  <text
                    id="Button2Text"
                    class="bmg-science-animation-111"
                    transform="translate(315.21 578.14) scale(1.01 1)"
                  ><tspan class="bmg-science-animation-118">C</tspan><tspan
                    x="8.57"
                    y="0"
                  >omp</tspan><tspan
                    class="bmg-science-animation-119"
                    x="37.3"
                    y="0"
                  >r</tspan><tspan
                    x="42.36"
                    y="0"
                  >esssion </tspan><tspan
                    class="bmg-science-animation-120"
                    x="92.21"
                    y="0"
                  >L</tspan><tspan
                    x="99.41"
                    y="0"
                  >ost (</tspan><tspan
                    class="bmg-science-animation-121"
                    x="126.54"
                    y="0"
                  >3</tspan><tspan
                    x="133.58"
                    y="0"
                  >2)</tspan></text>
                  <g
                    id="Speaker-3"
                    data-name="Speaker"
                  >
                    <path
                      class="bmg-science-animation-1"
                      d="M473,574.65v4.94c0,.4,0,.8-.45,1s-.74-.06-1-.35c-.72-.72-1.45-1.42-2.15-2.16a1.22,1.22,0,0,0-1-.41c-.77,0-1.55,0-2.33,0s-1-.27-1-1c0-1.36,0-2.73,0-4.1,0-.63.29-.91.92-.92.84,0,1.67,0,2.5,0a1.54,1.54,0,0,0,.87-.36c.76-.7,1.47-1.45,2.2-2.18.29-.29.58-.55,1-.36s.47.57.47,1Z"
                    />
                    <path
                      class="bmg-science-animation-1"
                      d="M483,574.83a8.91,8.91,0,0,1-3.74,7c-.49.35-1,.35-1.24,0s-.16-.84.35-1.23a7.32,7.32,0,0,0,.37-11.63c-.17-.14-.36-.26-.53-.41a.74.74,0,0,1-.2-1.07.7.7,0,0,1,1.09-.11,17.18,17.18,0,0,1,2.23,2.2A8.6,8.6,0,0,1,483,574.83Z"
                    />
                    <path
                      class="bmg-science-animation-1"
                      d="M480,574.72a5.87,5.87,0,0,1-2.52,4.67c-.46.33-.86.31-1.13,0s-.16-.75.21-1.13a9.64,9.64,0,0,0,1.33-1.46,4.18,4.18,0,0,0-.94-5.36c-.17-.14-.34-.28-.5-.44a.74.74,0,0,1,.94-1.13,5.63,5.63,0,0,1,2.47,3.79C479.94,574,480,574.4,480,574.72Z"
                    />
                    <path
                      class="bmg-science-animation-1"
                      d="M477,574.72a2.74,2.74,0,0,1-1.27,2.21c-.39.23-.8.29-1.1-.1a.71.71,0,0,1,.2-1.07,1.22,1.22,0,0,0,.56-1.39,2.22,2.22,0,0,0-.55-.79c-.31-.32-.51-.65-.23-1.08s.63-.42,1.12-.13A2.8,2.8,0,0,1,477,574.72Z"
                    />
                  </g>
                </g>
              </g>
              <g
                id="ControlButton1"
                class="pointer animation-google-tracking"
                tracking-info="Animation Audio #1 Started"
                @click="doSequenceButtonClick(1)"
              >
                <rect
                  id="Button1Background"
                  class="bmg-science-animation-110"
                  x="11"
                  y="559"
                  width="248"
                  height="30"
                />
                <g>
                  <text
                    id="Button1Text"
                    class="bmg-science-animation-111"
                    transform="translate(74 578.14) scale(1.01 1)"
                  >Int<tspan
                    class="bmg-science-animation-122"
                    x="17.45"
                    y="0"
                  >r</tspan><tspan
                    x="22.51"
                    y="0"
                  >odu</tspan><tspan
                    class="bmg-science-animation-123"
                    x="46.92"
                    y="0"
                  >c</tspan><tspan
                    x="54.11"
                    y="0"
                  >tion (54s)</tspan></text>
                  <g
                    id="Speaker-4"
                    data-name="Speaker"
                  >
                    <path
                      class="bmg-science-animation-1"
                      d="M201.09,574.65c0,1.65,0,3.29,0,4.94,0,.4,0,.8-.46,1s-.74-.06-1-.35c-.72-.72-1.45-1.42-2.16-2.16a1.21,1.21,0,0,0-1-.41c-.78,0-1.56,0-2.33,0s-1-.27-1-1c0-1.36,0-2.73,0-4.1,0-.63.3-.91.93-.92.83,0,1.66,0,2.49,0a1.54,1.54,0,0,0,.87-.36c.76-.7,1.48-1.45,2.21-2.18.28-.29.58-.55,1-.36s.47.57.47,1C201.08,571.36,201.09,573,201.09,574.65Z"
                    />
                    <path
                      class="bmg-science-animation-1"
                      d="M211.09,574.83a8.91,8.91,0,0,1-3.74,7c-.48.35-1,.35-1.24,0s-.16-.84.36-1.23a7.31,7.31,0,0,0,.36-11.63c-.17-.14-.35-.26-.52-.41a.74.74,0,0,1-.2-1.07.69.69,0,0,1,1.08-.11,17.26,17.26,0,0,1,2.24,2.2A8.6,8.6,0,0,1,211.09,574.83Z"
                    />
                    <path
                      class="bmg-science-animation-1"
                      d="M208.09,574.72a5.86,5.86,0,0,1-2.51,4.67c-.46.33-.87.31-1.14,0s-.15-.75.21-1.13a8.7,8.7,0,0,0,1.33-1.46,4.17,4.17,0,0,0-.94-5.36,5.12,5.12,0,0,1-.49-.44.72.72,0,0,1-.11-1,.7.7,0,0,1,1-.13,5.68,5.68,0,0,1,2.48,3.79C208,574,208.05,574.4,208.09,574.72Z"
                    />
                    <path
                      class="bmg-science-animation-1"
                      d="M205.09,574.72a2.74,2.74,0,0,1-1.27,2.21.77.77,0,0,1-1.1-.1.71.71,0,0,1,.21-1.07,1.23,1.23,0,0,0,.56-1.39,2.13,2.13,0,0,0-.56-.79c-.31-.32-.5-.65-.23-1.08s.64-.42,1.12-.13A2.8,2.8,0,0,1,205.09,574.72Z"
                    />
                  </g>
                </g>
              </g>
            </g>
            <g
              id="Pause-ResumeButton"
              class="pointer"
              @click="doPauseResumeButtonClick()"
            >
              <g id="Pause-ResumeBackground">
                <circle
                  class="bmg-science-animation-124"
                  cx="1015"
                  cy="515"
                  r="25"
                />
              </g>
              <g id="PauseBars">
                <line
                  class="bmg-science-animation-125"
                  x1="1008.93"
                  y1="502.14"
                  x2="1008.93"
                  y2="527.86"
                />
                <line
                  class="bmg-science-animation-125"
                  x1="1021.07"
                  y1="502.14"
                  x2="1021.07"
                  y2="527.86"
                />
              </g>
              <polygon
                id="ResumeTriangle"
                class="bmg-science-animation-1"
                points="1005 498.87 1033.57 515.37 1005 531.86 1005 498.87"
              />
            </g>
            <g
              id="StopButton"
              class="pointer"
              @click="doResetButtonClick()"
            >
              <g id="StopButtonBackground">
                <circle
                  class="bmg-science-animation-124"
                  cx="960"
                  cy="515"
                  r="25"
                />
              </g>
              <rect
                id="StopButtonRectangle"
                class="bmg-science-animation-1"
                x="948.5"
                y="503.5"
                width="23"
                height="23"
              />
            </g>
          </svg>
          <svg
            id="Zooms"
            v-show="showZoom1"
            class="bmg-science-anime-zoom"
            xmlns="http://www.w3.org/2000/svg"
            xmlns:xlink="http://www.w3.org/1999/xlink"
            :viewBox="zoomBox"
          >
            <g id="ZoomArea">
              <rect
                id="ZoomRect"
                v-show="showZoom1"
                class="bmg-zooms-1"
                x="2"
                y="2"
                width="1050"
                height="600"
              />
              <rect
                id="ExtraZoomRect"
                v-show="showZoom2"
                class="bmg-zooms-1"
                x="2"
                y="604"
                width="1050"
                height="600"
              />
              <rect
                id="_2ndExtraZoomRect"
                v-show="showZoom3"
                data-name="2ndExtraZoomRect"
                class="bmg-zooms-1"
                x="2"
                y="1207.75"
                width="1050"
                height="600"
              />
              <rect
                id="_3rdExtraZoomRect"
                v-show="showZoom4"
                data-name="3rdExtraZoomRect"
                class="bmg-zooms-1"
                x="2"
                y="1811.65"
                width="1050"
                height="600"
              />
              <g id="BrokenBonesZoom">
                <image
                  id="BrokenBonesPic"
                  width="1708"
                  height="940"
                  transform="translate(50.6 2.88) scale(0.56 0.64)"
                  :xlink:href="require('../assets/medical_pics/SurgicallyAssistedFractureRepair.jpg')"
                />
              </g>
              <g id="InternalFixationZoom">
                <image
                  id="HumanStressReactionPic"
                  width="1920"
                  height="1080"
                  transform="translate(26.96 624.06) scale(0.52)"
                  :xlink:href="require('../assets/medical_pics/HumanBoneStressReactionRange.jpg')"
                />
                <image
                  id="InternalFixationPic"
                  width="3101"
                  height="1743"
                  transform="translate(21.69 17.98) scale(0.33)"
                  :xlink:href="require('../assets/medical_pics/DanSurgery.jpg')"
                />
                <g id="InternalFixationText">
                  <text
                    id="InternalFixationHeading"
                    class="bmg-zooms-2"
                    transform="translate(376.62 122.42)"
                  >In<tspan
                    class="bmg-zooms-3"
                    x="35.66"
                    y="0"
                  >t</tspan><tspan
                    x="50.29"
                    y="0"
                  >e</tspan><tspan
                    class="bmg-zooms-4"
                    x="72.38"
                    y="0"
                  >r</tspan><tspan
                    x="87.32"
                    y="0"
                  >nal </tspan><tspan
                    class="bmg-zooms-5"
                    x="153.54"
                    y="0"
                  >F</tspan><tspan
                    x="175.56"
                    y="0"
                  >i</tspan><tspan
                    class="bmg-zooms-5"
                    x="186.09"
                    y="0"
                  >x</tspan><tspan
                    x="206.57"
                    y="0"
                  >ation</tspan></text>
                  <text
                    id="InternalFixationBodyText"
                    class="bmg-zooms-6"
                    transform="translate(291.23 173.22)"
                  >Su<tspan
                    class="bmg-zooms-7"
                    x="37.1"
                    y="0"
                  >r</tspan><tspan
                    x="48.92"
                    y="0"
                  >ge</tspan><tspan
                    class="bmg-zooms-8"
                    x="86.18"
                    y="0"
                  >r</tspan><tspan
                    x="98.67"
                    y="0"
                  >y</tspan><tspan class="bmg-zooms-9"><tspan
                    x="20"
                    y="24"
                  >Aims </tspan><tspan
                    class="bmg-zooms-3"
                    x="78.6"
                    y="24"
                  >t</tspan><tspan
                    x="86.96"
                    y="24"
                  >o </tspan><tspan
                    class="bmg-zooms-10"
                    x="105.72"
                    y="24"
                  >r</tspan><tspan
                    x="114.16"
                    y="24"
                  >edu</tspan><tspan
                    class="bmg-zooms-11"
                    x="154.36"
                    y="24"
                  >c</tspan><tspan
                    x="166.04"
                    y="24"
                  >e t</tspan><tspan
                    class="bmg-zooms-12"
                    x="193.02"
                    y="24"
                  >h</tspan><tspan
                    class="bmg-zooms-13"
                    x="206.96"
                    y="24"
                  >e </tspan><tspan
                    class="bmg-zooms-14"
                    x="225.24"
                    y="24"
                  >f</tspan><tspan
                    class="bmg-zooms-15"
                    x="234.58"
                    y="24"
                  >r</tspan><tspan
                    class="bmg-zooms-12"
                    x="243.06"
                    y="24"
                  >a</tspan><tspan
                    class="bmg-zooms-16"
                    x="255.52"
                    y="24"
                  >c</tspan><tspan
                    x="267.5"
                    y="24"
                  >tu</tspan><tspan
                    class="bmg-zooms-10"
                    x="289.94"
                    y="24"
                  >r</tspan><tspan
                    x="298.38"
                    y="24"
                  >e </tspan><tspan
                    class="bmg-zooms-17"
                    x="316.66"
                    y="24"
                  >b</tspan><tspan
                    x="330.16"
                    y="24"
                  >y </tspan><tspan
                    class="bmg-zooms-10"
                    x="347.78"
                    y="24"
                  >r</tspan><tspan
                    class="bmg-zooms-17"
                    x="356.22"
                    y="24"
                  >e</tspan><tspan
                    x="368.54"
                    y="24"
                  >aligni</tspan><tspan
                    class="bmg-zooms-18"
                    x="426.76"
                    y="24"
                  >n</tspan><tspan
                    x="440.7"
                    y="24"
                  >g </tspan><tspan
                    x="20"
                    y="48"
                  >a</tspan><tspan
                    class="bmg-zooms-12"
                    x="32.34"
                    y="48"
                  >n</tspan><tspan
                    x="46.28"
                    y="48"
                  >d </tspan><tspan
                    class="bmg-zooms-11"
                    x="65.78"
                    y="48"
                  >c</tspan><tspan
                    x="77.46"
                    y="48"
                  >omp</tspan><tspan
                    class="bmg-zooms-10"
                    x="125.34"
                    y="48"
                  >r</tspan><tspan
                    x="133.78"
                    y="48"
                  >essi</tspan><tspan
                    class="bmg-zooms-18"
                    x="173.66"
                    y="48"
                  >n</tspan><tspan
                    x="187.6"
                    y="48"
                  >g t</tspan><tspan
                    class="bmg-zooms-12"
                    x="215.96"
                    y="48"
                  >h</tspan><tspan
                    x="229.9"
                    y="48"
                  >e </tspan><tspan
                    class="bmg-zooms-19"
                    x="248.18"
                    y="48"
                  >f</tspan><tspan
                    class="bmg-zooms-11"
                    x="257.52"
                    y="48"
                  >r</tspan><tspan
                    class="bmg-zooms-12"
                    x="266"
                    y="48"
                  >a</tspan><tspan
                    class="bmg-zooms-16"
                    x="278.46"
                    y="48"
                  >c</tspan><tspan
                    x="290.44"
                    y="48"
                  >tu</tspan><tspan
                    class="bmg-zooms-10"
                    x="312.88"
                    y="48"
                  >r</tspan><tspan
                    x="321.32"
                    y="48"
                  >e </tspan><tspan
                    class="bmg-zooms-19"
                    x="339.6"
                    y="48"
                  >f</tspan><tspan
                    class="bmg-zooms-11"
                    x="348.94"
                    y="48"
                  >r</tspan><tspan
                    class="bmg-zooms-12"
                    x="357.42"
                    y="48"
                  >a</tspan><tspan
                    x="369.88"
                    y="48"
                  >g</tspan><tspan
                    class="bmg-zooms-18"
                    x="383.88"
                    y="48"
                  >m</tspan><tspan
                    x="404.98"
                    y="48"
                  >ents</tspan><tspan
                    class="bmg-zooms-3"
                    x="20"
                    y="72"
                  >t</tspan><tspan
                    x="28.36"
                    y="72"
                  >o all</tspan><tspan
                    class="bmg-zooms-17"
                    x="71.5"
                    y="72"
                  >o</tspan><tspan
                    x="84.3"
                    y="72"
                  >w p</tspan><tspan
                    class="bmg-zooms-10"
                    x="122.5"
                    y="72"
                  >r</tspan><tspan
                    x="130.94"
                    y="72"
                  >oper </tspan><tspan
                    class="bmg-zooms-18"
                    x="184.74"
                    y="72"
                  >h</tspan><tspan
                    class="bmg-zooms-17"
                    x="198.68"
                    y="72"
                  >e</tspan><tspan
                    x="211"
                    y="72"
                  >ali</tspan><tspan
                    class="bmg-zooms-12"
                    x="235.38"
                    y="72"
                  >n</tspan><tspan
                    x="249.32"
                    y="72"
                  >g</tspan></tspan><tspan
                    x="0"
                    y="105.6"
                  >G</tspan><tspan
                    class="bmg-zooms-7"
                    x="21.59"
                    y="105.6"
                  >o</tspan><tspan
                    x="39.68"
                    y="105.6"
                  >als</tspan><tspan class="bmg-zooms-9"><tspan
                    x="20"
                    y="129.6"
                  >Redu</tspan><tspan
                    class="bmg-zooms-11"
                    x="74.9"
                    y="129.6"
                  >c</tspan><tspan
                    x="86.58"
                    y="129.6"
                  >e </tspan><tspan
                    class="bmg-zooms-12"
                    x="104.86"
                    y="129.6"
                  >h</tspan><tspan
                    class="bmg-zooms-20"
                    x="118.8"
                    y="129.6"
                  >e</tspan><tspan
                    x="131.12"
                    y="129.6"
                  >ali</tspan><tspan
                    class="bmg-zooms-12"
                    x="155.5"
                    y="129.6"
                  >n</tspan><tspan
                    x="169.44"
                    y="129.6"
                  >g ti</tspan><tspan
                    class="bmg-zooms-12"
                    x="203.82"
                    y="129.6"
                  >m</tspan><tspan
                    x="224.92"
                    y="129.6"
                  >e</tspan><tspan
                    x="20"
                    y="153.6"
                  >Redu</tspan><tspan
                    class="bmg-zooms-11"
                    x="74.9"
                    y="153.6"
                  >c</tspan><tspan
                    x="86.58"
                    y="153.6"
                  >e </tspan><tspan
                    class="bmg-zooms-21"
                    x="104.86"
                    y="153.6"
                  >r</tspan><tspan
                    x="113.4"
                    y="153.6"
                  >isk of </tspan><tspan
                    class="bmg-zooms-11"
                    x="175.4"
                    y="153.6"
                  >c</tspan><tspan
                    x="187.08"
                    y="153.6"
                  >omplications</tspan></tspan></text>
                </g>
              </g>
              <g id="DeadBone">
                <image
                  id="NecroticBonePic"
                  width="1920"
                  height="1080"
                  transform="translate(19.5 619.2) scale(0.53)"
                  :xlink:href="require('../assets/medical_pics/NecroticBoneResorbed.jpg')"
                />
                <image
                  id="DeadBoneImage"
                  width="1920"
                  height="1080"
                  transform="translate(25.99 20.18) scale(0.52)"
                  :xlink:href="require('../assets/medical_pics/BoneDiesOnBothSidesOfTheFractureZone.jpg')"
                />
              </g>
              <g id="HighlyRestrictedZoom">
                <image
                  id="HighlyRestrictedPic2"
                  width="1920"
                  height="1080"
                  transform="translate(19.5 619) scale(0.53)"
                  :xlink:href="require('../assets/medical_pics/HighlyRestrictedEarlyWeightBearingAndExercise.jpg')"
                />
                <image
                  id="HighlyRestrictedPic1"
                  width="1760"
                  height="990"
                  transform="translate(19.5 16.53) scale(0.58)"
                  :xlink:href="require('../assets/medical_pics/ConventionalHardwareParitallyClosesResorptionGaps.jpg')"
                />
              </g>
              <g id="CompressionLostZoom">
                <image
                  width="1493"
                  height="819"
                  transform="translate(20.28 43.81) scale(0.68)"
                  :xlink:href="require('../assets/animations/Zooms3.jpg')"
                />
                <text
                  id="CompressionLostHeading"
                  class="bmg-zooms-22"
                  transform="translate(234.11 37.04)"
                ><tspan class="bmg-zooms-23">C</tspan><tspan
                  x="19.99"
                  y="0"
                >omp</tspan><tspan
                  class="bmg-zooms-7"
                  x="87.02"
                  y="0"
                >r</tspan><tspan
                  x="98.84"
                  y="0"
                >ession </tspan><tspan
                  class="bmg-zooms-24"
                  x="200.28"
                  y="0"
                >L</tspan><tspan
                  x="217.08"
                  y="0"
                >ost - Se</tspan><tspan
                  class="bmg-zooms-25"
                  x="324.66"
                  y="0"
                >c</tspan><tspan
                  x="341.01"
                  y="0"
                >o</tspan><tspan
                  class="bmg-zooms-26"
                  x="359.35"
                  y="0"
                >n</tspan><tspan
                  class="bmg-zooms-27"
                  x="378.86"
                  y="0"
                >da</tspan><tspan
                  class="bmg-zooms-28"
                  x="415.52"
                  y="0"
                >r</tspan><tspan
                  x="428"
                  y="0"
                >y H</tspan><tspan
                  class="bmg-zooms-29"
                  x="475.29"
                  y="0"
                >e</tspan><tspan
                  x="492.54"
                  y="0"
                >ali</tspan><tspan
                  class="bmg-zooms-30"
                  x="526.67"
                  y="0"
                >n</tspan><tspan
                  class="bmg-zooms-31"
                  x="546.19"
                  y="0"
                >g</tspan></text>
                <g id="HorseComplicationsZoom">
                  <image
                    width="1920"
                    height="1080"
                    transform="translate(19.5 1827) scale(0.53)"
                    :xlink:href="require('../assets/medical_pics/DescriptionOfConventionalEquineHardwareFailureMechanism.jpg')"
                  />
                  <image
                    width="1920"
                    height="1080"
                    transform="translate(20 1222) scale(0.53)"
                    :xlink:href="require('../assets/medical_pics/HorseLongBoneFracturesNoHardwareExists.jpg')"
                  />
                </g>
                <g id="HumanComplicationsZoom">
                  <image
                    id="HumanComplicationsPic"
                    width="1000"
                    height="667"
                    transform="translate(19.5 622) scale(1.02 0.85)"
                    :xlink:href="require('../assets/purchased_pics/shutterstock_1271305915_1000x667.jpg')"
                  />
                  <g id="HumanComplicationsText">
                    <text
                      id="HumanComplicationsHeading"
                      class="bmg-zooms-32"
                      transform="translate(160.62 721.53)"
                    >Resu<tspan
                      class="bmg-zooms-33"
                      x="72.35"
                      y="0"
                    >l</tspan><tspan
                      class="bmg-zooms-31"
                      x="81.87"
                      y="0"
                    >ts of </tspan><tspan
                      class="bmg-zooms-23"
                      x="153.94"
                      y="0"
                    >C</tspan><tspan
                      x="173.93"
                      y="0"
                    >omp</tspan><tspan
                      class="bmg-zooms-7"
                      x="240.96"
                      y="0"
                    >r</tspan><tspan
                      x="252.78"
                      y="0"
                    >ession </tspan><tspan
                      class="bmg-zooms-24"
                      x="354.22"
                      y="0"
                    >L</tspan><tspan
                      x="371.02"
                      y="0"
                    >oss </tspan><tspan
                      class="bmg-zooms-29"
                      x="427.02"
                      y="0"
                    >b</tspan><tspan
                      x="445.92"
                      y="0"
                    >y </tspan><tspan
                      class="bmg-zooms-34"
                      x="470.59"
                      y="0"
                    >F</tspan><tspan
                      class="bmg-zooms-25"
                      x="488.2"
                      y="0"
                    >r</tspan><tspan
                      class="bmg-zooms-30"
                      x="500.07"
                      y="0"
                    >a</tspan><tspan
                      class="bmg-zooms-35"
                      x="517.52"
                      y="0"
                    >c</tspan><tspan
                      x="534.29"
                      y="0"
                    >tu</tspan><tspan
                      class="bmg-zooms-7"
                      x="565.71"
                      y="0"
                    >r</tspan><tspan
                      x="577.52"
                      y="0"
                    >es </tspan><tspan
                      class="bmg-zooms-34"
                      x="617.98"
                      y="0"
                    >F</tspan><tspan
                      x="635.59"
                      y="0"
                    >i</tspan><tspan
                      class="bmg-zooms-34"
                      x="644.02"
                      y="0"
                    >x</tspan><tspan
                      x="660.4"
                      y="0"
                    >a</tspan><tspan
                      class="bmg-zooms-36"
                      x="677.68"
                      y="0"
                    >t</tspan><tspan
                      x="689.38"
                      y="0"
                    >ed</tspan><tspan
                      x="171.36"
                      y="36"
                    >with </tspan><tspan
                      class="bmg-zooms-37"
                      x="245.47"
                      y="36"
                    >T</tspan><tspan
                      class="bmg-zooms-38"
                      x="262.44"
                      y="36"
                    >r</tspan><tspan
                      class="bmg-zooms-30"
                      x="274.31"
                      y="36"
                    >a</tspan><tspan
                      class="bmg-zooms-27"
                      x="291.76"
                      y="36"
                    >ditional Ha</tspan><tspan
                      class="bmg-zooms-7"
                      x="451.38"
                      y="36"
                    >r</tspan><tspan
                      class="bmg-zooms-27"
                      x="463.2"
                      y="36"
                    >d</tspan><tspan
                      class="bmg-zooms-39"
                      x="482.57"
                      y="36"
                    >w</tspan><tspan
                      x="508.31"
                      y="36"
                    >a</tspan><tspan
                      class="bmg-zooms-7"
                      x="525.58"
                      y="36"
                    >r</tspan><tspan
                      x="537.4"
                      y="36"
                    >e</tspan></text>
                    <text
                      id="HumanComplicationBody"
                      class="bmg-zooms-40"
                      transform="translate(48.82 829.03)"
                    >Gap wideni<tspan
                      class="bmg-zooms-41"
                      x="113.58"
                      y="0"
                    >n</tspan><tspan
                      x="127.16"
                      y="0"
                    >g </tspan><tspan
                      class="bmg-zooms-42"
                      x="146.12"
                      y="0"
                    >r</tspan><tspan
                      x="153.88"
                      y="0"
                    >esu</tspan><tspan
                      class="bmg-zooms-43"
                      x="189.2"
                      y="0"
                    >l</tspan><tspan
                      x="194.62"
                      y="0"
                    >ts in t</tspan><tspan
                      class="bmg-zooms-43"
                      x="250.04"
                      y="0"
                    >h</tspan><tspan
                      x="263.62"
                      y="0"
                    >e </tspan><tspan
                      class="bmg-zooms-44"
                      x="280.94"
                      y="0"
                    >t</tspan><tspan
                      x="288.68"
                      y="0"
                    >otal loss of </tspan><tspan
                      class="bmg-zooms-45"
                      x="399.04"
                      y="0"
                    >c</tspan><tspan
                      x="410.11"
                      y="0"
                    >omp</tspan><tspan
                      class="bmg-zooms-42"
                      x="457.43"
                      y="0"
                    >r</tspan><tspan
                      x="465.19"
                      y="0"
                    >ession a</tspan><tspan
                      class="bmg-zooms-41"
                      x="545.33"
                      y="0"
                    >n</tspan><tspan
                      class="bmg-zooms-46"
                      x="558.91"
                      y="0"
                    >d ma</tspan><tspan
                      class="bmg-zooms-47"
                      x="610.73"
                      y="0"
                    >k</tspan><tspan
                      class="bmg-zooms-13"
                      x="622.33"
                      y="0"
                    >es </tspan><tspan
                      class="bmg-zooms-19"
                      x="649.43"
                      y="0"
                    >f</tspan><tspan
                      class="bmg-zooms-10"
                      x="657.81"
                      y="0"
                    >r</tspan><tspan
                      class="bmg-zooms-48"
                      x="665.65"
                      y="0"
                    >a</tspan><tspan
                      class="bmg-zooms-18"
                      x="677.49"
                      y="0"
                    >c</tspan><tspan
                      x="688.87"
                      y="0"
                    >tu</tspan><tspan
                      class="bmg-zooms-42"
                      x="710.45"
                      y="0"
                    >r</tspan><tspan
                      x="718.21"
                      y="0"
                    >e </tspan><tspan
                      class="bmg-zooms-10"
                      x="735.53"
                      y="0"
                    >z</tspan><tspan
                      x="745.57"
                      y="0"
                    >o</tspan><tspan
                      class="bmg-zooms-43"
                      x="758.11"
                      y="0"
                    >n</tspan><tspan
                      x="771.69"
                      y="0"
                    >e stabili</tspan><tspan
                      class="bmg-zooms-49"
                      x="848.41"
                      y="0"
                    >t</tspan><tspan
                      x="856.33"
                      y="0"
                    >y </tspan><tspan
                      x="0"
                      y="20"
                    >depe</tspan><tspan
                      class="bmg-zooms-43"
                      x="51.28"
                      y="20"
                    >n</tspan><tspan
                      x="64.86"
                      y="20"
                    >dent enti</tspan><tspan
                      class="bmg-zooms-42"
                      x="156.52"
                      y="20"
                    >r</tspan><tspan
                      x="164.28"
                      y="20"
                    >ely on ha</tspan><tspan
                      class="bmg-zooms-50"
                      x="254.48"
                      y="20"
                    >r</tspan><tspan
                      x="262.24"
                      y="20"
                    >d</tspan><tspan
                      class="bmg-zooms-51"
                      x="275.8"
                      y="20"
                    >w</tspan><tspan
                      class="bmg-zooms-46"
                      x="293.06"
                      y="20"
                    >a</tspan><tspan
                      class="bmg-zooms-42"
                      x="304.86"
                      y="20"
                    >r</tspan><tspan
                      class="bmg-zooms-13"
                      x="312.62"
                      y="20"
                    >e.</tspan><tspan
                      x="0"
                      y="60"
                    >A</tspan><tspan
                      class="bmg-zooms-43"
                      x="14.34"
                      y="60"
                    >l</tspan><tspan
                      x="19.76"
                      y="60"
                    >t</tspan><tspan
                      class="bmg-zooms-41"
                      x="27.88"
                      y="60"
                    >h</tspan><tspan
                      x="41.46"
                      y="60"
                    >ough </tspan><tspan
                      class="bmg-zooms-17"
                      x="99.96"
                      y="60"
                    >w</tspan><tspan
                      x="117.24"
                      y="60"
                    >eight b</tspan><tspan
                      class="bmg-zooms-17"
                      x="188.88"
                      y="60"
                    >e</tspan><tspan
                      x="200.66"
                      y="60"
                    >a</tspan><tspan
                      class="bmg-zooms-52"
                      x="212.46"
                      y="60"
                    >r</tspan><tspan
                      x="220.32"
                      y="60"
                    >i</tspan><tspan
                      class="bmg-zooms-43"
                      x="225.7"
                      y="60"
                    >n</tspan><tspan
                      x="239.28"
                      y="60"
                    >g a</tspan><tspan
                      class="bmg-zooms-43"
                      x="270.04"
                      y="60"
                    >n</tspan><tspan
                      x="283.62"
                      y="60"
                    >d </tspan><tspan
                      class="bmg-zooms-17"
                      x="302.42"
                      y="60"
                    >e</tspan><tspan
                      class="bmg-zooms-44"
                      x="314.2"
                      y="60"
                    >x</tspan><tspan
                      x="324.5"
                      y="60"
                    >e</tspan><tspan
                      class="bmg-zooms-42"
                      x="336.58"
                      y="60"
                    >r</tspan><tspan
                      x="344.33"
                      y="60"
                    >cise a</tspan><tspan
                      class="bmg-zooms-42"
                      x="399.87"
                      y="60"
                    >r</tspan><tspan
                      x="407.63"
                      y="60"
                    >e highly desi</tspan><tspan
                      class="bmg-zooms-10"
                      x="533.39"
                      y="60"
                    >r</tspan><tspan
                      x="541.23"
                      y="60"
                    >able </tspan><tspan
                      class="bmg-zooms-53"
                      x="589.29"
                      y="60"
                    >t</tspan><tspan
                      x="597.03"
                      y="60"
                    >o </tspan><tspan
                      class="bmg-zooms-49"
                      x="614.81"
                      y="60"
                    >a</tspan><tspan
                      class="bmg-zooms-17"
                      x="626.41"
                      y="60"
                    >v</tspan><tspan
                      x="636.95"
                      y="60"
                    >oid at</tspan><tspan
                      class="bmg-zooms-42"
                      x="693.59"
                      y="60"
                    >r</tspan><tspan
                      x="701.35"
                      y="60"
                    >op</tspan><tspan
                      class="bmg-zooms-49"
                      x="727.45"
                      y="60"
                    >h</tspan><tspan
                      x="740.79"
                      y="60"
                    >y of bo</tspan><tspan
                      class="bmg-zooms-43"
                      x="807.53"
                      y="60"
                    >n</tspan><tspan
                      x="821.11"
                      y="60"
                    >es, mus</tspan><tspan
                      class="bmg-zooms-52"
                      x="896.91"
                      y="60"
                    >c</tspan><tspan
                      x="908.01"
                      y="60"
                    >les, </tspan><tspan
                      x="0"
                      y="80"
                    >liga</tspan><tspan
                      class="bmg-zooms-43"
                      x="36.28"
                      y="80"
                    >m</tspan><tspan
                      x="57.54"
                      y="80"
                    >ents, </tspan><tspan
                      class="bmg-zooms-44"
                      x="110.54"
                      y="80"
                    >t</tspan><tspan
                      x="118.28"
                      y="80"
                    >e</tspan><tspan
                      class="bmg-zooms-41"
                      x="130.36"
                      y="80"
                    >n</tspan><tspan
                      x="143.94"
                      y="80"
                    >dons a</tspan><tspan
                      class="bmg-zooms-41"
                      x="210.4"
                      y="80"
                    >n</tspan><tspan
                      x="223.98"
                      y="80"
                    >d </tspan><tspan
                      class="bmg-zooms-43"
                      x="242.78"
                      y="80"
                    >n</tspan><tspan
                      class="bmg-zooms-13"
                      x="256.36"
                      y="80"
                    >eu</tspan><tspan
                      class="bmg-zooms-42"
                      x="281.9"
                      y="80"
                    >r</tspan><tspan
                      class="bmg-zooms-17"
                      x="289.66"
                      y="80"
                    >o</tspan><tspan
                      class="bmg-zooms-54"
                      x="301.9"
                      y="80"
                    >v</tspan><tspan
                      x="312.42"
                      y="80"
                    >ascular bu</tspan><tspan
                      class="bmg-zooms-41"
                      x="416.17"
                      y="80"
                    >n</tspan><tspan
                      x="429.75"
                      y="80"
                    >dles, loss of </tspan><tspan
                      class="bmg-zooms-10"
                      x="547.31"
                      y="80"
                    >c</tspan><tspan
                      x="558.39"
                      y="80"
                    >omp</tspan><tspan
                      class="bmg-zooms-50"
                      x="605.71"
                      y="80"
                    >r</tspan><tspan
                      class="bmg-zooms-13"
                      x="613.47"
                      y="80"
                    >ession </tspan><tspan
                      class="bmg-zooms-43"
                      x="681.81"
                      y="80"
                    >m</tspan><tspan
                      class="bmg-zooms-20"
                      x="703.07"
                      y="80"
                    >e</tspan><tspan
                      class="bmg-zooms-46"
                      x="714.85"
                      y="80"
                    >ans in</tspan><tspan
                      class="bmg-zooms-44"
                      x="774.13"
                      y="80"
                    >t</tspan><tspan
                      x="781.87"
                      y="80"
                    >er</tspan><tspan
                      class="bmg-zooms-55"
                      x="801.97"
                      y="80"
                    >f</tspan><tspan
                      class="bmg-zooms-56"
                      x="810.35"
                      y="80"
                    >r</tspan><tspan
                      class="bmg-zooms-43"
                      x="818.19"
                      y="80"
                    >a</tspan><tspan
                      x="830.03"
                      y="80"
                    >g</tspan><tspan
                      class="bmg-zooms-43"
                      x="843.75"
                      y="80"
                    >m</tspan><tspan
                      class="bmg-zooms-13"
                      x="865.01"
                      y="80"
                    >enta</tspan><tspan
                      class="bmg-zooms-57"
                      x="910.55"
                      y="80"
                    >r</tspan><tspan
                      x="918.87"
                      y="80"
                    >y</tspan><tspan
                      class="bmg-zooms-43"
                      x="0"
                      y="100"
                    >m</tspan><tspan
                      class="bmg-zooms-17"
                      x="21.26"
                      y="100"
                    >ov</tspan><tspan
                      class="bmg-zooms-13"
                      x="44.04"
                      y="100"
                    >e</tspan><tspan
                      class="bmg-zooms-43"
                      x="56.12"
                      y="100"
                    >m</tspan><tspan
                      x="77.38"
                      y="100"
                    >ent must be </tspan><tspan
                      class="bmg-zooms-50"
                      x="205.06"
                      y="100"
                    >r</tspan><tspan
                      class="bmg-zooms-13"
                      x="212.82"
                      y="100"
                    >esis</tspan><tspan
                      class="bmg-zooms-53"
                      x="249.84"
                      y="100"
                    >t</tspan><tspan
                      x="257.58"
                      y="100"
                    >ed enti</tspan><tspan
                      class="bmg-zooms-42"
                      x="327.58"
                      y="100"
                    >r</tspan><tspan
                      x="335.33"
                      y="100"
                    >ely </tspan><tspan
                      class="bmg-zooms-17"
                      x="368.88"
                      y="100"
                    >b</tspan><tspan
                      x="382.13"
                      y="100"
                    >y t</tspan><tspan
                      class="bmg-zooms-43"
                      x="406.33"
                      y="100"
                    >h</tspan><tspan
                      x="419.91"
                      y="100"
                    >e ha</tspan><tspan
                      class="bmg-zooms-42"
                      x="462.57"
                      y="100"
                    >r</tspan><tspan
                      class="bmg-zooms-46"
                      x="470.33"
                      y="100"
                    >d</tspan><tspan
                      class="bmg-zooms-51"
                      x="483.89"
                      y="100"
                    >w</tspan><tspan
                      x="501.15"
                      y="100"
                    >a</tspan><tspan
                      class="bmg-zooms-42"
                      x="512.95"
                      y="100"
                    >r</tspan><tspan
                      x="520.71"
                      y="100"
                    >e. </tspan><tspan
                      class="bmg-zooms-58"
                      x="0"
                      y="120"
                    /><tspan
                      x="48.41"
                      y="120"
                    >This is because t</tspan><tspan
                      class="bmg-zooms-43"
                      x="211.61"
                      y="120"
                    >h</tspan><tspan
                      x="225.19"
                      y="120"
                    >e bo</tspan><tspan
                      class="bmg-zooms-43"
                      x="268.61"
                      y="120"
                    >n</tspan><tspan
                      x="282.19"
                      y="120"
                    >e is </tspan><tspan
                      class="bmg-zooms-43"
                      x="319.91"
                      y="120"
                    >n</tspan><tspan
                      x="333.49"
                      y="120"
                    >o lo</tspan><tspan
                      class="bmg-zooms-43"
                      x="369.19"
                      y="120"
                    >n</tspan><tspan
                      x="382.77"
                      y="120"
                    >ger </tspan><tspan
                      class="bmg-zooms-49"
                      x="421.83"
                      y="120"
                    >e</tspan><tspan
                      class="bmg-zooms-17"
                      x="433.71"
                      y="120"
                    >v</tspan><tspan
                      x="444.25"
                      y="120"
                    >en </tspan><tspan
                      class="bmg-zooms-44"
                      x="475.11"
                      y="120"
                    >t</tspan><tspan
                      x="482.85"
                      y="120"
                    >ou</tspan><tspan
                      class="bmg-zooms-52"
                      x="508.85"
                      y="120"
                    >c</tspan><tspan
                      x="519.95"
                      y="120"
                    >hi</tspan><tspan
                      class="bmg-zooms-43"
                      x="538.87"
                      y="120"
                    >n</tspan><tspan
                      x="552.45"
                      y="120"
                    >g </tspan><tspan
                      class="bmg-zooms-43"
                      x="571.41"
                      y="120"
                    >a</tspan><tspan
                      x="583.25"
                      y="120"
                    >c</tspan><tspan
                      class="bmg-zooms-42"
                      x="594.51"
                      y="120"
                    >r</tspan><tspan
                      x="602.27"
                      y="120"
                    >oss t</tspan><tspan
                      class="bmg-zooms-43"
                      x="647.73"
                      y="120"
                    >h</tspan><tspan
                      x="661.31"
                      y="120"
                    >e wide</tspan><tspan
                      class="bmg-zooms-43"
                      x="727.23"
                      y="120"
                    >n</tspan><tspan
                      x="740.81"
                      y="120"
                    >ed gap of t</tspan><tspan
                      class="bmg-zooms-43"
                      x="848.69"
                      y="120"
                    >h</tspan><tspan
                      x="862.27"
                      y="120"
                    >e</tspan><tspan
                      class="bmg-zooms-58"
                      x="0"
                      y="140"
                    /><tspan
                      class="bmg-zooms-19"
                      x="48.41"
                      y="140"
                    >f</tspan><tspan
                      class="bmg-zooms-10"
                      x="56.79"
                      y="140"
                    >r</tspan><tspan
                      class="bmg-zooms-43"
                      x="64.63"
                      y="140"
                    >a</tspan><tspan
                      class="bmg-zooms-12"
                      x="76.47"
                      y="140"
                    >c</tspan><tspan
                      x="87.85"
                      y="140"
                    >tu</tspan><tspan
                      class="bmg-zooms-42"
                      x="109.43"
                      y="140"
                    >r</tspan><tspan
                      x="117.19"
                      y="140"
                    >e </tspan><tspan
                      class="bmg-zooms-10"
                      x="134.51"
                      y="140"
                    >z</tspan><tspan
                      x="144.55"
                      y="140"
                    >o</tspan><tspan
                      class="bmg-zooms-43"
                      x="157.09"
                      y="140"
                    >n</tspan><tspan
                      x="170.67"
                      y="140"
                    >e. </tspan><tspan
                      class="bmg-zooms-58"
                      x="0"
                      y="160"
                    /><tspan
                      x="48.41"
                      y="160"
                    >T</tspan><tspan
                      class="bmg-zooms-43"
                      x="59.89"
                      y="160"
                    >h</tspan><tspan
                      x="73.47"
                      y="160"
                    >e</tspan><tspan
                      class="bmg-zooms-42"
                      x="85.55"
                      y="160"
                    >r</tspan><tspan
                      x="93.31"
                      y="160"
                    >e is </tspan><tspan
                      class="bmg-zooms-43"
                      x="131.03"
                      y="160"
                    >n</tspan><tspan
                      x="144.61"
                      y="160"
                    >o </tspan><tspan
                      class="bmg-zooms-42"
                      x="162.39"
                      y="160"
                    >r</tspan><tspan
                      x="170.15"
                      y="160"
                    >emaini</tspan><tspan
                      class="bmg-zooms-43"
                      x="239.55"
                      y="160"
                    >n</tspan><tspan
                      x="253.13"
                      y="160"
                    >g bo</tspan><tspan
                      class="bmg-zooms-43"
                      x="298.19"
                      y="160"
                    >n</tspan><tspan
                      x="311.77"
                      y="160"
                    >e </tspan><tspan
                      class="bmg-zooms-44"
                      x="329.09"
                      y="160"
                    >t</tspan><tspan
                      x="336.83"
                      y="160"
                    >o bo</tspan><tspan
                      class="bmg-zooms-43"
                      x="380.71"
                      y="160"
                    >n</tspan><tspan
                      x="394.29"
                      y="160"
                    >e axial l</tspan><tspan
                      class="bmg-zooms-59"
                      x="467.27"
                      y="160"
                    >o</tspan><tspan
                      class="bmg-zooms-43"
                      x="479.75"
                      y="160"
                    >a</tspan><tspan
                      x="491.59"
                      y="160"
                    >d t</tspan><tspan
                      class="bmg-zooms-10"
                      x="518.51"
                      y="160"
                    >r</tspan><tspan
                      x="526.35"
                      y="160"
                    >ans</tspan><tspan
                      class="bmg-zooms-10"
                      x="561.47"
                      y="160"
                    >f</tspan><tspan
                      x="568.07"
                      y="160"
                    >e</tspan><tspan
                      class="bmg-zooms-60"
                      x="580.15"
                      y="160"
                    >r</tspan><tspan
                      x="587.97"
                      y="160"
                    >, </tspan><tspan
                      class="bmg-zooms-43"
                      x="597.45"
                      y="160"
                    >n</tspan><tspan
                      x="611.03"
                      y="160"
                    >o </tspan><tspan
                      class="bmg-zooms-19"
                      x="628.81"
                      y="160"
                    >f</tspan><tspan
                      class="bmg-zooms-52"
                      x="637.19"
                      y="160"
                    >r</tspan><tspan
                      x="645.05"
                      y="160"
                    >i</tspan><tspan
                      class="bmg-zooms-12"
                      x="650.43"
                      y="160"
                    >c</tspan><tspan
                      x="661.81"
                      y="160"
                    >tion </tspan><tspan
                      class="bmg-zooms-42"
                      x="706.63"
                      y="160"
                    >r</tspan><tspan
                      x="714.39"
                      y="160"
                    >esista</tspan><tspan
                      class="bmg-zooms-43"
                      x="771.33"
                      y="160"
                    >n</tspan><tspan
                      class="bmg-zooms-10"
                      x="784.91"
                      y="160"
                    >c</tspan><tspan
                      x="795.99"
                      y="160"
                    >e </tspan><tspan
                      class="bmg-zooms-44"
                      x="813.31"
                      y="160"
                    >t</tspan><tspan
                      x="821.05"
                      y="160"
                    >o </tspan><tspan
                      class="bmg-zooms-44"
                      x="838.83"
                      y="160"
                    >t</tspan><tspan
                      x="846.57"
                      y="160"
                    >o</tspan><tspan
                      class="bmg-zooms-21"
                      x="859.11"
                      y="160"
                    >r</tspan><tspan
                      x="867.05"
                      y="160"
                    >sion</tspan><tspan
                      class="bmg-zooms-58"
                      x="0"
                      y="180"
                    /><tspan
                      x="48.41"
                      y="180"
                    >or s</tspan><tspan
                      class="bmg-zooms-43"
                      x="83.99"
                      y="180"
                    >h</tspan><tspan
                      class="bmg-zooms-17"
                      x="97.57"
                      y="180"
                    >e</tspan><tspan
                      x="109.35"
                      y="180"
                    >a</tspan><tspan
                      class="bmg-zooms-49"
                      x="121.15"
                      y="180"
                    >r</tspan><tspan
                      x="128.97"
                      y="180"
                    >. </tspan><tspan
                      x="0"
                      y="220"
                    >S</tspan><tspan
                      class="bmg-zooms-17"
                      x="12.3"
                      y="220"
                    >o</tspan><tspan
                      class="bmg-zooms-13"
                      x="24.54"
                      y="220"
                    >, </tspan><tspan
                      class="bmg-zooms-44"
                      x="34.02"
                      y="220"
                    >t</tspan><tspan
                      x="41.76"
                      y="220"
                    >o </tspan><tspan
                      class="bmg-zooms-60"
                      x="59.54"
                      y="220"
                    >a</tspan><tspan
                      class="bmg-zooms-20"
                      x="71.14"
                      y="220"
                    >v</tspan><tspan
                      x="81.68"
                      y="220"
                    >oid ha</tspan><tspan
                      class="bmg-zooms-42"
                      x="143.74"
                      y="220"
                    >r</tspan><tspan
                      class="bmg-zooms-46"
                      x="151.5"
                      y="220"
                    >d</tspan><tspan
                      class="bmg-zooms-51"
                      x="165.06"
                      y="220"
                    >w</tspan><tspan
                      x="182.32"
                      y="220"
                    >a</tspan><tspan
                      class="bmg-zooms-42"
                      x="194.12"
                      y="220"
                    >r</tspan><tspan
                      x="201.88"
                      y="220"
                    >e </tspan><tspan
                      class="bmg-zooms-49"
                      x="219.2"
                      y="220"
                    >f</tspan><tspan
                      x="225.78"
                      y="220"
                    >ailu</tspan><tspan
                      class="bmg-zooms-42"
                      x="261.8"
                      y="220"
                    >r</tspan><tspan
                      x="269.56"
                      y="220"
                    >e, malunion or </tspan><tspan
                      class="bmg-zooms-41"
                      x="419.02"
                      y="220"
                    >n</tspan><tspan
                      x="432.59"
                      y="220"
                    >onunion; </tspan><tspan
                      class="bmg-zooms-17"
                      x="526.61"
                      y="220"
                    >e</tspan><tspan
                      x="538.39"
                      y="220"
                    >a</tspan><tspan
                      class="bmg-zooms-52"
                      x="550.19"
                      y="220"
                    >r</tspan><tspan
                      x="558.05"
                      y="220"
                    >ly </tspan><tspan
                      class="bmg-zooms-17"
                      x="579.51"
                      y="220"
                    >w</tspan><tspan
                      class="bmg-zooms-13"
                      x="596.79"
                      y="220"
                    >eight b</tspan><tspan
                      class="bmg-zooms-20"
                      x="668.43"
                      y="220"
                    >e</tspan><tspan
                      x="680.21"
                      y="220"
                    >a</tspan><tspan
                      class="bmg-zooms-61"
                      x="692.01"
                      y="220"
                    >r</tspan><tspan
                      x="699.87"
                      y="220"
                    >i</tspan><tspan
                      class="bmg-zooms-43"
                      x="705.25"
                      y="220"
                    >n</tspan><tspan
                      x="718.83"
                      y="220"
                    >g, a</tspan><tspan
                      class="bmg-zooms-41"
                      x="753.83"
                      y="220"
                    >n</tspan><tspan
                      class="bmg-zooms-46"
                      x="767.41"
                      y="220"
                    >d </tspan><tspan
                      class="bmg-zooms-17"
                      x="786.21"
                      y="220"
                    >e</tspan><tspan
                      class="bmg-zooms-44"
                      x="797.99"
                      y="220"
                    >x</tspan><tspan
                      x="808.29"
                      y="220"
                    >e</tspan><tspan
                      class="bmg-zooms-42"
                      x="820.37"
                      y="220"
                    >r</tspan><tspan
                      x="828.13"
                      y="220"
                    >cise must</tspan><tspan
                      x="0"
                      y="240"
                    >be </tspan><tspan
                      class="bmg-zooms-42"
                      x="30.88"
                      y="240"
                    >r</tspan><tspan
                      x="38.64"
                      y="240"
                    >edu</tspan><tspan
                      class="bmg-zooms-10"
                      x="77.74"
                      y="240"
                    >c</tspan><tspan
                      class="bmg-zooms-13"
                      x="88.82"
                      y="240"
                    >ed </tspan><tspan
                      class="bmg-zooms-44"
                      x="119.7"
                      y="240"
                    >t</tspan><tspan
                      x="127.44"
                      y="240"
                    >o bel</tspan><tspan
                      class="bmg-zooms-17"
                      x="176.24"
                      y="240"
                    >o</tspan><tspan
                      x="188.48"
                      y="240"
                    >w l</tspan><tspan
                      class="bmg-zooms-49"
                      x="216.68"
                      y="240"
                    >e</tspan><tspan
                      class="bmg-zooms-17"
                      x="228.56"
                      y="240"
                    >v</tspan><tspan
                      class="bmg-zooms-13"
                      x="239.1"
                      y="240"
                    >els whi</tspan><tspan
                      class="bmg-zooms-61"
                      x="308.08"
                      y="240"
                    >c</tspan><tspan
                      class="bmg-zooms-13"
                      x="319.18"
                      y="240"
                    >h a</tspan><tspan
                      class="bmg-zooms-42"
                      x="349.76"
                      y="240"
                    >r</tspan><tspan
                      x="357.52"
                      y="240"
                    >e insufficient </tspan><tspan
                      class="bmg-zooms-44"
                      x="493.15"
                      y="240"
                    >t</tspan><tspan
                      x="500.89"
                      y="240"
                    >o </tspan><tspan
                      class="bmg-zooms-60"
                      x="518.67"
                      y="240"
                    >a</tspan><tspan
                      class="bmg-zooms-17"
                      x="530.27"
                      y="240"
                    >v</tspan><tspan
                      class="bmg-zooms-13"
                      x="540.81"
                      y="240"
                    >oid at</tspan><tspan
                      class="bmg-zooms-42"
                      x="597.45"
                      y="240"
                    >r</tspan><tspan
                      x="605.21"
                      y="240"
                    >op</tspan><tspan
                      class="bmg-zooms-49"
                      x="631.31"
                      y="240"
                    >h</tspan><tspan
                      class="bmg-zooms-62"
                      x="644.65"
                      y="240"
                    >y</tspan><tspan
                      x="654.81"
                      y="240"
                    >. </tspan><tspan
                      class="bmg-zooms-58"
                      x="0"
                      y="260"
                    /><tspan
                      class="bmg-zooms-63"
                      x="48.41"
                      y="260"
                    >A</tspan><tspan
                      class="bmg-zooms-10"
                      x="62.65"
                      y="260"
                    >cc</tspan><tspan
                      x="84.81"
                      y="260"
                    >o</tspan><tspan
                      class="bmg-zooms-42"
                      x="97.35"
                      y="260"
                    >r</tspan><tspan
                      x="105.11"
                      y="260"
                    >di</tspan><tspan
                      class="bmg-zooms-43"
                      x="124.05"
                      y="260"
                    >n</tspan><tspan
                      x="137.63"
                      y="260"
                    >gl</tspan><tspan
                      class="bmg-zooms-62"
                      x="156.73"
                      y="260"
                    >y</tspan><tspan
                      x="166.89"
                      y="260"
                    >, at</tspan><tspan
                      class="bmg-zooms-50"
                      x="196.29"
                      y="260"
                    >r</tspan><tspan
                      class="bmg-zooms-13"
                      x="204.05"
                      y="260"
                    >op</tspan><tspan
                      class="bmg-zooms-49"
                      x="230.15"
                      y="260"
                    >h</tspan><tspan
                      x="243.49"
                      y="260"
                    >y </tspan><tspan
                      class="bmg-zooms-19"
                      x="259.57"
                      y="260"
                    >f</tspan><tspan
                      class="bmg-zooms-42"
                      x="267.95"
                      y="260"
                    >r</tspan><tspan
                      x="275.71"
                      y="260"
                    >om 8 </tspan><tspan
                      class="bmg-zooms-44"
                      x="332.71"
                      y="260"
                    >t</tspan><tspan
                      x="340.45"
                      y="260"
                    >o 16 </tspan><tspan
                      class="bmg-zooms-17"
                      x="382.87"
                      y="260"
                    >w</tspan><tspan
                      x="400.15"
                      y="260"
                    >ee</tspan><tspan
                      class="bmg-zooms-51"
                      x="424.31"
                      y="260"
                    >k</tspan><tspan
                      x="436.01"
                      y="260"
                    >s of s</tspan><tspan
                      class="bmg-zooms-60"
                      x="485.37"
                      y="260"
                    >e</tspan><tspan
                      class="bmg-zooms-20"
                      x="497.25"
                      y="260"
                    >v</tspan><tspan
                      x="507.79"
                      y="260"
                    >e</tspan><tspan
                      class="bmg-zooms-42"
                      x="519.87"
                      y="260"
                    >r</tspan><tspan
                      x="527.63"
                      y="260"
                    >ely </tspan><tspan
                      class="bmg-zooms-42"
                      x="561.17"
                      y="260"
                    >r</tspan><tspan
                      x="568.93"
                      y="260"
                    >est</tspan><tspan
                      class="bmg-zooms-61"
                      x="598.91"
                      y="260"
                    >r</tspan><tspan
                      x="606.77"
                      y="260"
                    >i</tspan><tspan
                      class="bmg-zooms-12"
                      x="612.15"
                      y="260"
                    >c</tspan><tspan
                      class="bmg-zooms-53"
                      x="623.53"
                      y="260"
                    >t</tspan><tspan
                      x="631.27"
                      y="260"
                    >ed </tspan><tspan
                      class="bmg-zooms-20"
                      x="662.15"
                      y="260"
                    >w</tspan><tspan
                      x="679.43"
                      y="260"
                    >eight b</tspan><tspan
                      class="bmg-zooms-17"
                      x="751.07"
                      y="260"
                    >e</tspan><tspan
                      x="762.85"
                      y="260"
                    >a</tspan><tspan
                      class="bmg-zooms-52"
                      x="774.65"
                      y="260"
                    >r</tspan><tspan
                      x="782.51"
                      y="260"
                    >i</tspan><tspan
                      class="bmg-zooms-43"
                      x="787.89"
                      y="260"
                    >n</tspan><tspan
                      x="801.47"
                      y="260"
                    >g a</tspan><tspan
                      class="bmg-zooms-43"
                      x="832.23"
                      y="260"
                    >n</tspan><tspan
                      x="845.81"
                      y="260"
                    >d</tspan><tspan
                      class="bmg-zooms-58"
                      x="0"
                      y="280"
                    /><tspan
                      x="48.41"
                      y="280"
                    >se</tspan><tspan
                      class="bmg-zooms-10"
                      x="70.27"
                      y="280"
                    >c</tspan><tspan
                      x="81.35"
                      y="280"
                    >o</tspan><tspan
                      class="bmg-zooms-43"
                      x="93.89"
                      y="280"
                    >n</tspan><tspan
                      x="107.47"
                      y="280"
                    >da</tspan><tspan
                      class="bmg-zooms-57"
                      x="132.83"
                      y="280"
                    >r</tspan><tspan
                      x="141.15"
                      y="280"
                    >y </tspan><tspan
                      class="bmg-zooms-43"
                      x="157.23"
                      y="280"
                    >h</tspan><tspan
                      class="bmg-zooms-17"
                      x="170.81"
                      y="280"
                    >e</tspan><tspan
                      x="182.59"
                      y="280"
                    >ali</tspan><tspan
                      class="bmg-zooms-43"
                      x="205.15"
                      y="280"
                    >n</tspan><tspan
                      x="218.73"
                      y="280"
                    >g a</tspan><tspan
                      class="bmg-zooms-42"
                      x="249.49"
                      y="280"
                    >r</tspan><tspan
                      x="257.25"
                      y="280"
                    >e t</tspan><tspan
                      class="bmg-zooms-43"
                      x="282.69"
                      y="280"
                    >h</tspan><tspan
                      x="296.27"
                      y="280"
                    >e cu</tspan><tspan
                      class="bmg-zooms-52"
                      x="338.31"
                      y="280"
                    >r</tspan><tspan
                      class="bmg-zooms-42"
                      x="346.17"
                      y="280"
                    >r</tspan><tspan
                      x="353.93"
                      y="280"
                    >ent sta</tspan><tspan
                      class="bmg-zooms-43"
                      x="422.61"
                      y="280"
                    >n</tspan><tspan
                      x="436.19"
                      y="280"
                    >da</tspan><tspan
                      class="bmg-zooms-42"
                      x="461.55"
                      y="280"
                    >r</tspan><tspan
                      x="469.31"
                      y="280"
                    >d of ca</tspan><tspan
                      class="bmg-zooms-42"
                      x="535.73"
                      y="280"
                    >r</tspan><tspan
                      x="543.49"
                      y="280"
                    >e </tspan><tspan
                      class="bmg-zooms-10"
                      x="560.81"
                      y="280"
                    >f</tspan><tspan
                      x="567.41"
                      y="280"
                    >or humans.</tspan></text>
                  </g>
                </g>
              </g>
              <g id="SecondaryHealingZoom">
                <image
                  id="SecondaryHealingPic"
                  width="1500"
                  height="844"
                  transform="translate(27.5 35.22) scale(0.67)"
                  :xlink:href="require('../assets/medical_pics/IMG_9_Secondary_Healing_Progress_D3.jpg')"
                />
                <text
                  id="SecondaryHealingHeading"
                  class="bmg-zooms-64"
                  transform="translate(314.64 34.04)"
                >Se<tspan
                  class="bmg-zooms-38"
                  x="35.53"
                  y="0"
                >c</tspan><tspan
                  x="51.88"
                  y="0"
                >o</tspan><tspan
                  class="bmg-zooms-30"
                  x="70.22"
                  y="0"
                >n</tspan><tspan
                  x="89.74"
                  y="0"
                >da</tspan><tspan
                  class="bmg-zooms-8"
                  x="126.39"
                  y="0"
                >r</tspan><tspan
                  class="bmg-zooms-27"
                  x="138.88"
                  y="0"
                >y H</tspan><tspan
                  class="bmg-zooms-29"
                  x="186.17"
                  y="0"
                >e</tspan><tspan
                  x="203.42"
                  y="0"
                >ali</tspan><tspan
                  class="bmg-zooms-26"
                  x="237.55"
                  y="0"
                >n</tspan><tspan
                  x="257.07"
                  y="0"
                >g </tspan><tspan
                  class="bmg-zooms-49"
                  x="284.59"
                  y="0"
                >P</tspan><tspan
                  class="bmg-zooms-7"
                  x="304.8"
                  y="0"
                >r</tspan><tspan
                  x="316.62"
                  y="0"
                >o</tspan><tspan
                  class="bmg-zooms-25"
                  x="334.96"
                  y="0"
                >c</tspan><tspan
                  x="351.31"
                  y="0"
                >ess</tspan></text>
              </g>
              <g id="SecondaryHaversianRemodelingZoom">
                <image
                  id="SecondaryHealingPic-2"
                  data-name="SecondaryHealingPic"
                  width="1500"
                  height="844"
                  transform="translate(32 36.81) scale(0.66)"
                  :xlink:href="require('../assets/medical_pics/IMG_8_Secondary_Healing_D3.jpg')"
                />
                <text
                  id="SecondaryHealingHeading-2"
                  data-name="SecondaryHealingHeading"
                  class="bmg-zooms-64"
                  transform="translate(268.92 30.37)"
                >Se<tspan
                  class="bmg-zooms-38"
                  x="35.53"
                  y="0"
                >c</tspan><tspan
                  x="51.88"
                  y="0"
                >o</tspan><tspan
                  class="bmg-zooms-30"
                  x="70.22"
                  y="0"
                >n</tspan><tspan
                  x="89.74"
                  y="0"
                >da</tspan><tspan
                  class="bmg-zooms-8"
                  x="126.39"
                  y="0"
                >r</tspan><tspan
                  class="bmg-zooms-27"
                  x="138.88"
                  y="0"
                >y H</tspan><tspan
                  class="bmg-zooms-34"
                  x="186.17"
                  y="0"
                >a</tspan><tspan
                  class="bmg-zooms-65"
                  x="203.17"
                  y="0"
                >v</tspan><tspan
                  x="219.49"
                  y="0"
                >e</tspan><tspan
                  class="bmg-zooms-66"
                  x="237.16"
                  y="0"
                >r</tspan><tspan
                  class="bmg-zooms-27"
                  x="249.17"
                  y="0"
                >sian Re</tspan><tspan
                  class="bmg-zooms-30"
                  x="355.26"
                  y="0"
                >m</tspan><tspan
                  x="384.8"
                  y="0"
                >odeli</tspan><tspan
                  class="bmg-zooms-30"
                  x="457.04"
                  y="0"
                >n</tspan><tspan
                  x="476.55"
                  y="0"
                >g</tspan></text>
              </g>
              <g id="SecondaryFinalBone">
                <image
                  id="SecondaryFinalBonePic"
                  width="1920"
                  height="1080"
                  transform="translate(19.5 16.53) scale(0.53)"
                  :xlink:href="require('../assets/medical_pics/SecondaryHealingFullyRestoredBone.jpg')"
                />
              </g>
              <g id="BMGHardwareZoom">
                <image
                  id="BMGHardwarePic2"
                  width="1920"
                  height="1080"
                  transform="translate(19.5 618) scale(0.53)"
                  :xlink:href="require('../assets/medical_pics/FullEarlyWeightBearingBenefits.jpg')"
                />
                <image
                  id="BMGHardwarePic1"
                  width="1920"
                  height="1080"
                  transform="translate(19.5 16.53) scale(0.53)"
                  :xlink:href="require('../assets/medical_pics/BMGInventedHardwareToCloseResorptionGaps.jpg')"
                />
              </g>
              <g id="IntimateAlignmentZoom">
                <image
                  id="IntimateAlignmentPic2"
                  width="1920"
                  height="1080"
                  transform="translate(20 618) scale(0.53)"
                  :xlink:href="require('../assets/medical_pics/BridgingMedicalHardwareCombinations.jpg')"
                />
                <image
                  id="IntimateAlignmentPic1"
                  width="1791"
                  height="1043"
                  transform="translate(19.5 6.45) scale(0.57)"
                  :xlink:href="require('../assets/medical_pics/BMGHardwareSustainedCompressionInducesIntimateAlignmentBold.jpg')"
                />
              </g>
              <g id="DirectHaversianZoom">
                <image
                  id="DirectHaversianPic"
                  width="1500"
                  height="844"
                  transform="translate(19.5 16.45) scale(0.68)"
                  :xlink:href="require('../assets/medical_pics/IMG6_Haversian_Remodeling_D3.jpg')"
                />
              </g>
              <g id="PrimaryFinalBone">
                <image
                  id="PrimaryFinalBonePic"
                  width="1920"
                  height="1080"
                  transform="translate(19.5 16.53) scale(0.53)"
                  :xlink:href="require('../assets/medical_pics/PrimaryHealingFullyRestoredBone.jpg')"
                />
              </g>
              <g
                id="ZoomCloseButton4"
                v-show="showZoom4"
                class="pointer"
                @click="closeZoom()"
              >
                <circle
                  class="bmg-zooms-1"
                  cx="1027"
                  cy="1834.91"
                  r="23"
                />
                <text
                  class="bmg-zooms-67"
                  transform="translate(1017.08 1844.91)"
                >X</text>
              </g>
              <g
                id="ZoomCloseButton3"
                v-show="showZoom3"
                class="pointer"
                @click="closeZoom()"
              >
                <circle
                  class="bmg-zooms-1"
                  cx="1027"
                  cy="1231"
                  r="23"
                />
                <text
                  class="bmg-zooms-67"
                  transform="translate(1017.08 1241)"
                >X</text>
              </g>
              <g
                id="ZoomCloseButton2"
                v-show="showZoom2"
                class="pointer"
                @click="closeZoom()"
              >
                <circle
                  class="bmg-zooms-1"
                  cx="1027"
                  cy="627"
                  r="23"
                />
                <text
                  class="bmg-zooms-67"
                  transform="translate(1017.08 637)"
                >X</text>
              </g>
              <g
                id="ZoomCloseButton"
                v-show="showZoom1"
                class="pointer"
                @click="closeZoom()"
              >
                <circle
                  class="bmg-zooms-1"
                  cx="1027"
                  cy="27"
                  r="23"
                />
                <text
                  class="bmg-zooms-67"
                  transform="translate(1017.08 37)"
                >X</text>
              </g>
              <g id="MoreArrow">
                <rect
                  class="bmg-zooms-68"
                  x="514.19"
                  y="546.48"
                  width="24.81"
                  height="42.03"
                />
                <polygon
                  class="bmg-zooms-68"
                  points="504.07 585.88 549.93 585.88 527 625.59 504.07 585.88"
                />
              </g>
              <g
                id="_2ndMoreArrow"
                data-name="2ndMoreArrow"
              >
                <rect
                  class="bmg-zooms-68"
                  x="514.19"
                  y="1150.23"
                  width="24.81"
                  height="42.03"
                />
                <polygon
                  class="bmg-zooms-68"
                  points="504.07 1189.63 549.93 1189.63 527 1229.34 504.07 1189.63"
                />
              </g>
              <g
                id="_3rdMoreArrow"
                data-name="3rdMoreArrow"
              >
                <rect
                  class="bmg-zooms-68"
                  x="514.19"
                  y="1754.14"
                  width="24.81"
                  height="42.03"
                />
                <polygon
                  class="bmg-zooms-68"
                  points="504.07 1793.54 549.93 1793.54 527 1833.24 504.07 1793.54"
                />
              </g>
            </g>
          </svg>
        </div>
      </div>
    </div>
  </div><!-- End of OpportunityPage-->
</template>

<script>
import SecurityCheckMixin from './mixins/SecurityCheckMixin'
import anime from '../assets/animations/ScienceAnimation.js'
import {TimelineMax, CSSPlugin, AttrPlugin} from 'gsap/all'
// import 'gsap'

// Make sure babel doesn't trim the plugins from the DOM tree
const plugins = [ CSSPlugin, AttrPlugin ]
window.$ = require('jquery')

export default {
  mixins: [SecurityCheckMixin],
  name: 'SciencePage',
  data: function () {
    return {
      windowHeight: -1,
      windowWidth: -1,
      bannerHeight: 59,
      isPaused: false,
      zooming: false,
      showZoom1: false,
      showZoom2: false,
      showZoom3: false,
      showZoom4: false,
      zoomBox: '0 0 1054 603' // long= "0 0 1054 1206" extraLong= "0 0 1054 1809"
      // zoomStartTime: -1,
      // zoomDuration: -1
    }
  },
  computed: {},
  components: {
  },
  methods: {
    // trackUser: function (_type, _label) {
    //   switch (_type) {
    //     case 'open':{
    //       this.$gtm.trackEvent({
    //         event: 'animationInteractionEvent', // Event type [default = 'interaction'] (Optional)
    //         category: 'Animation',
    //         action: 'Zoom',
    //         label: _label,
    //         value: '' + Date.now(),
    //         noninteraction: false, // Is this NOT an interaction event... User events => false
    //         animationDetails: "Hi Aaron! You Rock!"
    //       })
    //       break
    //     }
    //     default:
    //
    //   }
    // },
    rotateBanner: function () {
      var banner = new TimelineMax({
        paused: false,
        repeat: -1,
        repeatDelay: 0,
        yoyo: false
      })
      banner.to('#banner2, #banner3, #banner4, #BannerLabel2, #BannerLabel3, #BannerLabel4', 0, {opacity: 0})
        .to('#banner1, #BannerLabel1', 5, {opacity: 1})
        .to('#banner1, #BannerLabel1', 1, {opacity: 0})
        .to('#banner3, #BannerLabel3', 1, {opacity: 1}, '-=1')
        .to('#banner3, #BannerLabel3', 5, {opacity: 1})
        .to('#banner3, #BannerLabel3', 1, {opacity: 0})
        .to('#banner2, #BannerLabel2', 1, {opacity: 1}, '-=1')
        .to('#banner2, #BannerLabel2', 5, {opacity: 1})
        .to('#banner2, #BannerLabel2', 1, {opacity: 0})
        .to('#banner4, #BannerLabel4', 1, {opacity: 1}, '-=1')
        .to('#banner4, #BannerLabel4', 5, {opacity: 1})
        .to('#banner4, #BannerLabel4', 1, {opacity: 0})
        .to('#banner1, #BannerLabel1', 1, {opacity: 1}, '-=1')
    },
    closeZoom: function () {
      // console.log('Closing the zoom...')
      anime.closeZoom()
      this.zooming = false
      // this.zoomDuration = Date.now() - this.zoomStartTime
      // this.zoomStartTime = -1
      // this.trackUser('close', 'closeZoom')
    },
    hideZoom: function () {
      // console.log('hideZoom called!')
      this.showZoom1 = false
      this.showZoom2 = false
      this.showZoom3 = false
      this.showZoom4 = false
    },
    doZoom: function (selection, numSections) {
      // console.log('doZoom', selection)
      this.zooming = true
      this.showZoom1 = true
      this.showZoom2 = false
      this.showZoom3 = false
      this.showZoom4 = false
      // We need to change the size of the zoomBox SVG ViewBox to accommodate
      //  the correct number of zoom windows
      switch (numSections) {
        case 2: {
          this.zoomBox = '0 0 1054 1206'
          this.showZoom2 = true
          break
        }
        case 3: {
          this.zoomBox = '0 0 1054 1809'
          this.showZoom2 = true
          this.showZoom3 = true
          break
        }
        case 4: {
          this.zoomBox = '0 0 1054 2412'
          this.showZoom2 = true
          this.showZoom3 = true
          this.showZoom4 = true
          break
        }
        default: {
          this.zoomBox = '0 0 1054 603'
        }
      }
      anime.doZoom(selection, numSections, this.hideZoom, this.zooming)

      // this.$gtm.dataLayer().push({
      //   animationClick: selection
      // })
      this.$gtm.trackEvent({
        event: 'animation-click-event',
        // category: 'User',
        // action: 'Animation Click',
        // label: selection,
        // value: null,
        nointeraction: false,
        animationClickTarget: selection
      })

      // debugger
      // Track the fact that the user clicked on a Zoom option
      // this.zoomStartTime = Date.now()
      // this.trackUser('open', selection)
    },
    doResetButtonClick () {
      this.isPaused = false
      anime.doResetAnime()
    },
    doPauseResumeButtonClick () {
      if (this.isPaused) {
        anime.doResumeAnime()
        this.isPaused = false
        if (!window.$('#ResumeTriangle').hasClass('invisible')) {
          window.$('#ResumeTriangle').addClass('invisible')
        }
        window.$('#PauseBars').removeClass('invisible')
      } else {
        anime.doPauseAnime()
        this.isPaused = true
        if (!window.$('#PauseBars').hasClass('invisible')) {
          window.$('#PauseBars').addClass('invisible')
        }
        window.$('#ResumeTriangle').removeClass('invisible')
      }
    },
    doSequenceButtonClick (s) {
      this.isPaused = false
      if (!window.$('#ResumeTriangle').hasClass('invisible')) {
        window.$('#ResumeTriangle').addClass('invisible')
      }
      window.$('#PauseBars').removeClass('invisible')
      anime.doSequence(s)

      this.$gtm.trackEvent({
        event: 'animation-click-event',
        // category: 'User',
        // action: 'Animation Click',
        // label: selection,
        // value: null,
        nointeraction: false,
        animationClickTarget: 'Audio Sequence #' + s
      })
    },
    respondToWindowSizeChange () {
      if (window.innerHeight) {
        this.windowHeight = window.innerHeight - this.bannerHeight
      } else if (document.body && document.body.offsetHeight) {
        this.windowHeight = document.body.offsetHeight - this.bannerHeight
      }

      if (window.innerWidth) {
        this.windowWidth = window.innerWidth
      } else if (document.body && document.body.offsetWidth) {
        this.windowWidth = document.body.offsetWidth
      }
      // console.log('Window = ' + this.windowWidth + ' x ' + this.windowHeight)
      // console.log('this.windowWidth = ', this.windowWidth)
      // console.log('this.windowHeight = ', this.windowHeight)
    },
    scrollToSection (section) {
      // console.log('Attempting to scroll to ' + section + ' section...')
      if (section) {
        var desiredSection = document.getElementById(section)
        // console.log('Section = ')
        // console.log(desiredSection)
        if (desiredSection) {
          desiredSection.scrollIntoView()
        }
      }
    }
  },
  beforeMount () {},
  mounted () {
    this.rotateBanner()
    this.respondToWindowSizeChange()
    window.addEventListener('resize', this.respondToWindowSizeChange)
    // console.log('Section = ' + this.$route.params.section)
    anime.doStartAnime()
    this.scrollToSection(this.$route.params.section)
  },
  beforeDestroy () {
    anime.doResetAnime()
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
